[
  {
    "id": "x",
    "name": "X",
    "methods": [
      "browser"
    ],
    "entry_url": "https://x.com/compose/post",
    "dynamic_host": false,
    "hosts": [
      "x.com"
    ],
    "preview": {
      "layout": "social",
      "fields": [
        {
          "key": "body",
          "label": [
            "Post",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 280,
          "transfer": "text",
          "selectors": [
            "[role=\"dialog\"] [data-testid=\"tweetTextarea_0\"][contenteditable=\"true\"]"
          ],
          "format": "plain",
          "length_metric": "twitter"
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": true,
        "transfer": "guided",
        "max_count": 4,
        "video_alone": true
      }
    },
    "unattended": {
      "account": "a[data-testid='AppTabBar_Profile_Link']",
      "submit": "[role='dialog'] [data-testid='tweetButton']",
      "result": "[data-testid='toast'] a[href*='/status/']"
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
    "publication_hosts": [
      "x.com",
      "twitter.com"
    ],
    "browser": {
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    }
  },
  {
    "id": "linkedin",
    "name": "LinkedIn",
    "methods": [
      "browser"
    ],
    "entry_url": "https://www.linkedin.com/sharing/compose",
    "dynamic_host": false,
    "hosts": [
      "linkedin.com"
    ],
    "preview": {
      "layout": "social",
      "fields": [
        {
          "key": "body",
          "label": [
            "Post",
            "动态"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 3000,
          "transfer": "text",
          "selectors": [
            "div[role=\"textbox\"].tiptap.ProseMirror",
            "[componentkey=\"ShareBox_textEditor\"]"
          ],
          "format": "plain"
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": true,
        "transfer": "guided",
        "video_alone": true
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "unattended": {
      "account": "a[data-view-name='identity-self-profile'][href*='/in/']",
      "submit": "button[data-view-name='share-post']",
      "result": "a[href*='/feed/update/urn:li:activity:'],a[href*='/posts/']"
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
  },
  {
    "id": "linkedin-page",
    "name": "LinkedIn Page",
    "methods": [
      "browser"
    ],
    "entry_url": "https://www.linkedin.com/company/",
    "dynamic_host": false,
    "hosts": [
      "linkedin.com"
    ],
    "preview": {
      "layout": "social",
      "fields": [
        {
          "key": "destination",
          "label": [
            "Page URL",
            "主页网址"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Post",
            "动态"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 3000,
          "transfer": "text",
          "selectors": [
            ".ql-editor[contenteditable=\"true\"]"
          ],
          "format": "plain"
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": true,
        "transfer": "guided",
        "video_alone": true
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
    "unattended": {
      "account": "a[href*='/company/'][href*='/admin']",
      "submit": "button.share-actions__primary-action",
      "submit_text": [
        "Post",
        "发布"
      ],
      "result": "a[href*='/feed/update/']"
    }
  },
  {
    "id": "reddit",
    "name": "Reddit",
    "methods": [
      "api",
      "browser"
    ],
    "credential_provider": "reddit",
    "credential_kind": "oauth",
    "entry_url": "https://www.reddit.com/submit",
    "dynamic_host": false,
    "hosts": [
      "reddit.com"
    ],
    "preview": {
      "layout": "discussion",
      "fields": [
        {
          "key": "community",
          "label": [
            "Community",
            "社区"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": 300,
          "transfer": "text",
          "selectors": [
            "textarea[name=\"title\"]",
            "input[name=\"title\"]"
          ]
        },
        {
          "key": "body",
          "label": [
            "Text",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 10000,
          "transfer": "text",
          "selectors": [
            "[contenteditable=\"true\"][role=\"textbox\"]"
          ],
          "format": "rich_text"
        },
        {
          "key": "flair",
          "label": [
            "Flair",
            "分类标签"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "nsfw",
          "label": [
            "Adult content",
            "成人内容"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "no",
            "yes"
          ],
          "option_labels": {
            "no": [
              "No",
              "否"
            ],
            "yes": [
              "Yes",
              "是"
            ]
          }
        },
        {
          "key": "spoiler",
          "label": [
            "Spoiler",
            "剧透"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "no",
            "yes"
          ],
          "option_labels": {
            "no": [
              "No",
              "否"
            ],
            "yes": [
              "Yes",
              "是"
            ]
          }
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "verified",
      "fill": "unattended",
      "final_action": "automated"
    },
    "unattended": {
      "account": "drafts-modal[prefixed-name]",
      "account_attribute": "prefixed-name",
      "submit": "r-post-form-submit-button#submit-post-button",
      "result": "a[href*='/comments/']",
      "lands_on_post": true,
      "handled_fields": [
        "community",
        "title"
      ]
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
  },
  {
    "id": "instagram",
    "name": "Instagram",
    "methods": [
      "browser"
    ],
    "entry_url": "https://www.instagram.com/",
    "dynamic_host": false,
    "hosts": [
      "instagram.com"
    ],
    "preview": {
      "layout": "gallery",
      "fields": [
        {
          "key": "body",
          "label": [
            "Caption",
            "说明"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 2200,
          "transfer": "text",
          "selectors": [
            "[contenteditable=\"true\"][role=\"textbox\"]",
            "[contenteditable=\"true\"][aria-label=\"Add a caption...\"]"
          ],
          "format": "plain"
        },
        {
          "key": "alt",
          "label": [
            "Alternative text",
            "图片替代文本"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "location",
          "label": [
            "Location",
            "地点"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "collaborators",
          "label": [
            "Collaborators",
            "协作者"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "ai_label",
          "label": [
            "AI label",
            "AI 标注"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "off",
            "on"
          ],
          "option_labels": {
            "off": [
              "No AI label",
              "不标注"
            ],
            "on": [
              "Made with AI",
              "标注为 AI 生成"
            ]
          }
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": true,
        "multiple": true,
        "transfer": "guided",
        "max_count": 10
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
    "unattended": {
      "account": "a[href^='/'][href$='/'] img[alt*='profile picture']",
      "submit": "div[role='button']",
      "submit_text": [
        "Share",
        "分享"
      ],
      "result": "a[href*='/p/'],a[href*='/reel/']"
    }
  },
  {
    "id": "instagram-standalone",
    "name": "Instagram (Instagram Login)",
    "methods": [
      "browser"
    ],
    "entry_url": "https://www.instagram.com/",
    "dynamic_host": false,
    "hosts": [
      "instagram.com"
    ],
    "preview": {
      "layout": "gallery",
      "fields": [
        {
          "key": "body",
          "label": [
            "Caption",
            "说明"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 2200,
          "transfer": "text",
          "selectors": [
            "[contenteditable=\"true\"][role=\"textbox\"]",
            "[contenteditable=\"true\"][aria-label=\"Add a caption...\"]"
          ],
          "format": "plain"
        },
        {
          "key": "alt",
          "label": [
            "Alternative text",
            "图片替代文本"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "location",
          "label": [
            "Location",
            "地点"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "collaborators",
          "label": [
            "Collaborators",
            "协作者"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "ai_label",
          "label": [
            "AI label",
            "AI 标注"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "off",
            "on"
          ],
          "option_labels": {
            "off": [
              "No AI label",
              "不标注"
            ],
            "on": [
              "Made with AI",
              "标注为 AI 生成"
            ]
          }
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": true,
        "multiple": true,
        "transfer": "guided",
        "max_count": 10
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
    "unattended": {
      "account": "a[href^='/'][href$='/'] img[alt*='profile picture']",
      "submit": "div[role='button']",
      "submit_text": [
        "Share",
        "分享"
      ],
      "result": "a[href*='/p/'],a[href*='/reel/']"
    }
  },
  {
    "id": "facebook",
    "name": "Facebook",
    "methods": [
      "browser"
    ],
    "entry_url": "https://www.facebook.com/",
    "dynamic_host": false,
    "hosts": [
      "facebook.com"
    ],
    "preview": {
      "layout": "social",
      "fields": [
        {
          "key": "destination",
          "label": [
            "Page or profile URL",
            "主页或个人页网址"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Post",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 63206,
          "transfer": "text",
          "selectors": [
            "[contenteditable=\"true\"][role=\"textbox\"][data-lexical-editor=\"true\"]"
          ],
          "format": "plain"
        },
        {
          "key": "audience",
          "label": [
            "Audience",
            "受众"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
    "unattended": {
      "account": "a[aria-label][href*='facebook.com/']",
      "submit": "div[role='button']",
      "submit_text": [
        "Post",
        "发布"
      ],
      "result": "a[href*='/posts/'],a[href*='/permalink/']"
    }
  },
  {
    "id": "threads",
    "name": "Threads",
    "methods": [
      "browser"
    ],
    "entry_url": "https://www.threads.com/",
    "dynamic_host": false,
    "hosts": [
      "threads.com"
    ],
    "preview": {
      "layout": "social",
      "fields": [
        {
          "key": "body",
          "label": [
            "Post",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 500,
          "transfer": "text",
          "selectors": [
            "[contenteditable=\"true\"][role=\"textbox\"]"
          ],
          "format": "plain"
        },
        {
          "key": "topic",
          "label": [
            "Topic",
            "话题"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "replies",
          "label": [
            "Who can reply",
            "谁可以回复"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
    "unattended": {
      "account": "a[href^='/@']",
      "submit": "div[role='button']",
      "submit_text": [
        "Post",
        "发布"
      ],
      "result": "a[href*='/post/']"
    }
  },
  {
    "id": "youtube",
    "name": "YouTube",
    "methods": [
      "api",
      "browser"
    ],
    "credential_provider": "google-youtube",
    "credential_kind": "oauth",
    "entry_url": "https://studio.youtube.com/?d=ud",
    "dynamic_host": false,
    "hosts": [
      "studio.youtube.com"
    ],
    "preview": {
      "layout": "video",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": 100,
          "transfer": "text",
          "selectors": [
            "#title-textarea #textbox"
          ],
          "min_length": 2
        },
        {
          "key": "body",
          "label": [
            "Description",
            "说明"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 5000,
          "transfer": "text",
          "selectors": [
            "#description-textarea #textbox"
          ],
          "format": "plain"
        },
        {
          "key": "visibility",
          "label": [
            "Visibility",
            "可见性"
          ],
          "kind": "select",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "public",
            "private",
            "unlisted"
          ],
          "option_labels": {
            "public": [
              "Public",
              "公开"
            ],
            "private": [
              "Private",
              "私密"
            ],
            "unlisted": [
              "Unlisted",
              "不公开列出"
            ]
          }
        },
        {
          "key": "kids",
          "label": [
            "Made for kids",
            "是否面向儿童"
          ],
          "kind": "select",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "yes",
            "no"
          ],
          "option_labels": {
            "yes": [
              "Yes",
              "是"
            ],
            "no": [
              "No",
              "否"
            ]
          }
        },
        {
          "key": "tags",
          "label": [
            "Tags",
            "标签"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "category",
          "label": [
            "Category",
            "类别"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "video/*",
        "required": true,
        "multiple": false,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "unattended": {
      "account": "a[href*='/channel/'],ytcp-entity-card a[href*='/channel/']",
      "submit": "ytcp-button#done-button",
      "result": "ytcp-video-share-dialog a[href*='youtu.be/'],ytcp-video-share-dialog a[href*='youtube.com/watch']",
      "handled_fields": [
        "kids",
        "visibility"
      ]
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
    "publication_hosts": [
      "youtube.com",
      "youtu.be"
    ]
  },
  {
    "id": "gmb",
    "name": "Google Business Profile",
    "methods": [
      "browser"
    ],
    "entry_url": "https://business.google.com/",
    "dynamic_host": false,
    "hosts": [
      "business.google.com"
    ],
    "preview": {
      "layout": "business",
      "fields": [
        {
          "key": "destination",
          "label": [
            "Business dashboard URL",
            "商家管理页网址"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Update",
            "最新动态"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 1500,
          "transfer": "guided",
          "selectors": [],
          "format": "plain"
        },
        {
          "key": "cta",
          "label": [
            "Action button",
            "行动按钮"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "NONE",
            "BOOK",
            "ORDER",
            "SHOP",
            "LEARN_MORE",
            "SIGN_UP",
            "GET_OFFER",
            "CALL"
          ],
          "option_labels": {
            "NONE": [
              "None",
              "无"
            ],
            "BOOK": [
              "Book",
              "预订"
            ],
            "ORDER": [
              "Order online",
              "在线订购"
            ],
            "SHOP": [
              "Buy",
              "购买"
            ],
            "LEARN_MORE": [
              "Learn more",
              "了解详情"
            ],
            "SIGN_UP": [
              "Sign up",
              "注册"
            ],
            "GET_OFFER": [
              "Get offer",
              "领取优惠"
            ],
            "CALL": [
              "Call now",
              "立即致电"
            ]
          }
        },
        {
          "key": "link",
          "label": [
            "Button link",
            "按钮链接"
          ],
          "kind": "url",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": false,
        "transfer": "guided",
        "no_video": true
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
    "publication_hosts": [
      "google.com",
      "maps.app.goo.gl"
    ],
    "unattended": {
      "account": "a[href*='accounts.google.com/SignOutOptions']",
      "submit": "button",
      "submit_text": [
        "Post",
        "Publish",
        "发布"
      ],
      "result": "a[href*='/posts/']",
      "handled_fields": [
        "destination"
      ]
    }
  },
  {
    "id": "tiktok",
    "name": "TikTok",
    "methods": [
      "browser"
    ],
    "entry_url": "https://www.tiktok.com/tiktokstudio/upload",
    "dynamic_host": false,
    "hosts": [
      "tiktok.com"
    ],
    "preview": {
      "layout": "video",
      "fields": [
        {
          "key": "body",
          "label": [
            "Caption",
            "说明"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 4000,
          "transfer": "text",
          "selectors": [
            ".public-DraftEditor-content"
          ],
          "format": "plain"
        },
        {
          "key": "visibility",
          "label": [
            "Visibility",
            "可见性"
          ],
          "kind": "select",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "public",
            "friends",
            "followers",
            "private"
          ],
          "option_labels": {
            "public": [
              "Everyone",
              "所有人"
            ],
            "friends": [
              "Friends",
              "好友"
            ],
            "followers": [
              "Followers",
              "粉丝"
            ],
            "private": [
              "Only you",
              "仅自己"
            ]
          }
        },
        {
          "key": "comments",
          "label": [
            "Allow comments",
            "允许评论"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "yes",
            "no"
          ],
          "option_labels": {
            "yes": [
              "Yes",
              "是"
            ],
            "no": [
              "No",
              "否"
            ]
          }
        },
        {
          "key": "ai_generated",
          "label": [
            "AI-generated content",
            "AI 生成内容"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "yes",
            "no"
          ],
          "option_labels": {
            "yes": [
              "Yes",
              "是"
            ],
            "no": [
              "No",
              "否"
            ]
          }
        },
        {
          "key": "commercial",
          "label": [
            "Commercial content",
            "商业内容披露"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "none",
            "own_brand",
            "branded_content"
          ],
          "option_labels": {
            "none": [
              "None",
              "无"
            ],
            "own_brand": [
              "Your brand",
              "自有品牌"
            ],
            "branded_content": [
              "Branded content",
              "品牌合作内容"
            ]
          }
        },
        {
          "key": "reuse",
          "label": [
            "Reuse of content",
            "允许二次创作"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "on",
            "off"
          ],
          "option_labels": {
            "on": [
              "On",
              "开启"
            ],
            "off": [
              "Off",
              "关闭"
            ]
          }
        },
        {
          "key": "audience_control",
          "label": [
            "Adults only (18+)",
            "仅限成年人（18+）"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "on",
            "off"
          ],
          "option_labels": {
            "on": [
              "On",
              "开启"
            ],
            "off": [
              "Off",
              "关闭"
            ]
          }
        },
        {
          "key": "cover",
          "label": [
            "Cover",
            "封面"
          ],
          "kind": "image",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "accept": "image/*"
        },
        {
          "key": "location",
          "label": [
            "Location",
            "位置"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": true,
        "multiple": true,
        "transfer": "guided",
        "video_alone": true
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
    "unattended": {
      "account": "a[href*='/creator-center/'],a[href*='/@']",
      "submit": "button",
      "submit_text": [
        "Post",
        "发布"
      ],
      "result": "a[href*='/video/']"
    }
  },
  {
    "id": "tiktok-business",
    "name": "TikTok Business",
    "methods": [
      "browser"
    ],
    "entry_url": "https://www.tiktok.com/tiktokstudio/upload",
    "dynamic_host": false,
    "hosts": [
      "tiktok.com"
    ],
    "preview": {
      "layout": "video",
      "fields": [
        {
          "key": "body",
          "label": [
            "Caption",
            "说明"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 4000,
          "transfer": "text",
          "selectors": [
            ".public-DraftEditor-content"
          ],
          "format": "plain"
        },
        {
          "key": "visibility",
          "label": [
            "Visibility",
            "可见性"
          ],
          "kind": "select",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "public",
            "friends",
            "followers",
            "private"
          ],
          "option_labels": {
            "public": [
              "Everyone",
              "所有人"
            ],
            "friends": [
              "Friends",
              "好友"
            ],
            "followers": [
              "Followers",
              "粉丝"
            ],
            "private": [
              "Only you",
              "仅自己"
            ]
          }
        },
        {
          "key": "comments",
          "label": [
            "Allow comments",
            "允许评论"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "yes",
            "no"
          ],
          "option_labels": {
            "yes": [
              "Yes",
              "是"
            ],
            "no": [
              "No",
              "否"
            ]
          }
        },
        {
          "key": "ai_generated",
          "label": [
            "AI-generated content",
            "AI 生成内容"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "yes",
            "no"
          ],
          "option_labels": {
            "yes": [
              "Yes",
              "是"
            ],
            "no": [
              "No",
              "否"
            ]
          }
        },
        {
          "key": "commercial",
          "label": [
            "Commercial content",
            "商业内容披露"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "none",
            "own_brand",
            "branded_content"
          ],
          "option_labels": {
            "none": [
              "None",
              "无"
            ],
            "own_brand": [
              "Your brand",
              "自有品牌"
            ],
            "branded_content": [
              "Branded content",
              "品牌合作内容"
            ]
          }
        },
        {
          "key": "reuse",
          "label": [
            "Reuse of content",
            "允许二次创作"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "on",
            "off"
          ],
          "option_labels": {
            "on": [
              "On",
              "开启"
            ],
            "off": [
              "Off",
              "关闭"
            ]
          }
        },
        {
          "key": "audience_control",
          "label": [
            "Adults only (18+)",
            "仅限成年人（18+）"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "on",
            "off"
          ],
          "option_labels": {
            "on": [
              "On",
              "开启"
            ],
            "off": [
              "Off",
              "关闭"
            ]
          }
        },
        {
          "key": "cover",
          "label": [
            "Cover",
            "封面"
          ],
          "kind": "image",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "accept": "image/*"
        },
        {
          "key": "location",
          "label": [
            "Location",
            "位置"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": true,
        "multiple": true,
        "transfer": "guided",
        "video_alone": true,
        "max_count": 35
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
    "unattended": {
      "account": "a[href*='/creator-center/'],a[href*='/@']",
      "submit": "button",
      "submit_text": [
        "Post",
        "发布"
      ],
      "result": "a[href*='/video/']"
    }
  },
  {
    "id": "pinterest",
    "name": "Pinterest",
    "methods": [
      "browser"
    ],
    "entry_url": "https://www.pinterest.com/pin-creation-tool/",
    "dynamic_host": false,
    "hosts": [
      "pinterest.com"
    ],
    "preview": {
      "layout": "pin",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": false,
          "max_length": 100,
          "transfer": "text",
          "selectors": [
            "input#storyboard-selector-title"
          ]
        },
        {
          "key": "body",
          "label": [
            "Description",
            "说明"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 500,
          "transfer": "text",
          "selectors": [
            ".public-DraftEditor-content"
          ],
          "format": "plain"
        },
        {
          "key": "link",
          "label": [
            "Destination link",
            "目标链接"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input#WebsiteField"
          ]
        },
        {
          "key": "board",
          "label": [
            "Board",
            "画板"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "alt",
          "label": [
            "Alternative text",
            "图片替代文本"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "topics",
          "label": [
            "Topics",
            "标记主题"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "#combobox-storyboard-interest-tags"
          ]
        },
        {
          "key": "ai_disclosure",
          "label": [
            "AI disclosure",
            "标记为 AI 修改"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "none",
            "ai_made"
          ],
          "option_labels": {
            "none": [
              "Not AI-made",
              "非 AI 制作"
            ],
            "ai_made": [
              "Made wholly or partly by AI",
              "完全或部分由 AI 制作"
            ]
          }
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": true,
        "multiple": true,
        "transfer": "guided",
        "max_count": 5
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
    "unattended": {
      "account": "a[href*='/settings/']",
      "submit": "button",
      "submit_text": [
        "Publish",
        "发布"
      ],
      "result": "a[href*='/pin/']"
    }
  },
  {
    "id": "dribbble",
    "name": "Dribbble",
    "methods": [
      "browser"
    ],
    "entry_url": "https://dribbble.com/uploads/new",
    "dynamic_host": false,
    "hosts": [
      "dribbble.com"
    ],
    "preview": {
      "layout": "gallery",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": 64,
          "transfer": "text",
          "selectors": [
            "textarea#title"
          ]
        },
        {
          "key": "body",
          "label": [
            "Description",
            "说明"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 40000,
          "transfer": "text",
          "selectors": [
            "[contenteditable=\"true\"][role=\"textbox\"]"
          ],
          "format": "plain"
        },
        {
          "key": "tags",
          "label": [
            "Tags",
            "标签"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "team",
          "label": [
            "Team",
            "团队"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": true,
        "multiple": false,
        "transfer": "guided",
        "no_video": true
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
    "unattended": {
      "account": "a[href*='/account/'],a[href*='/shots/']",
      "submit": "button",
      "submit_text": [
        "Publish now",
        "Publish",
        "发布"
      ],
      "result": "a[href*='/shots/']"
    }
  },
  {
    "id": "discord",
    "name": "Discord",
    "methods": [
      "browser"
    ],
    "entry_url": "https://discord.com/channels/@me",
    "dynamic_host": false,
    "hosts": [
      "discord.com"
    ],
    "preview": {
      "layout": "chat",
      "fields": [
        {
          "key": "destination",
          "label": [
            "Channel URL",
            "频道网址"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Message",
            "消息"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 1980,
          "transfer": "text",
          "selectors": [
            "[role=\"textbox\"][data-slate-editor=\"true\"]"
          ],
          "format": "plain"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
    "unattended": {
      "account": "button[aria-label*='User Settings'],button[aria-label*='用户设置']",
      "submit": "[data-ondit-enter-submit]",
      "submit_key": "Enter",
      "result": "a[href*='/channels/']",
      "handled_fields": [
        "destination"
      ]
    }
  },
  {
    "id": "slack",
    "name": "Slack",
    "methods": [
      "browser"
    ],
    "entry_url": "https://app.slack.com/",
    "dynamic_host": false,
    "hosts": [
      "app.slack.com"
    ],
    "preview": {
      "layout": "chat",
      "fields": [
        {
          "key": "destination",
          "label": [
            "Channel URL",
            "频道网址"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Message",
            "消息"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 400000,
          "transfer": "text",
          "selectors": [
            "[data-message-input=\"true\"] [contenteditable=\"true\"]"
          ],
          "format": "plain"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
    "publication_hosts": [
      "slack.com"
    ],
    "unattended": {
      "account": "button[data-qa='user-button']",
      "submit": "button[data-qa='texty_send_button']",
      "submit_key": "Enter",
      "result": "a[href*='/archives/'][href*='/p']",
      "handled_fields": [
        "destination"
      ]
    }
  },
  {
    "id": "kick",
    "name": "Kick",
    "methods": [
      "browser"
    ],
    "entry_url": "https://kick.com/",
    "dynamic_host": false,
    "hosts": [
      "kick.com"
    ],
    "preview": {
      "layout": "chat",
      "fields": [
        {
          "key": "destination",
          "label": [
            "Channel URL",
            "直播频道网址"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Chat message",
            "聊天消息"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 500,
          "transfer": "text",
          "selectors": [
            "#message-input"
          ],
          "format": "plain"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
    "unattended": {
      "account": "button[aria-label*='profile' i]",
      "submit": "button[type='submit']",
      "submit_key": "Enter",
      "result": "a[href*='/messages/']",
      "handled_fields": [
        "destination"
      ]
    }
  },
  {
    "id": "twitch",
    "name": "Twitch",
    "methods": [
      "browser"
    ],
    "entry_url": "https://www.twitch.tv/",
    "dynamic_host": false,
    "hosts": [
      "twitch.tv"
    ],
    "preview": {
      "layout": "chat",
      "fields": [
        {
          "key": "destination",
          "label": [
            "Channel URL",
            "直播频道网址"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Chat message",
            "聊天消息"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 500,
          "transfer": "text",
          "selectors": [
            "[data-a-target=\"chat-input\"]"
          ],
          "format": "plain"
        },
        {
          "key": "messageType",
          "label": [
            "Message type",
            "消息类型"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "message",
            "announcement"
          ],
          "option_labels": {
            "message": [
              "Chat message",
              "聊天消息"
            ],
            "announcement": [
              "Announcement",
              "公告"
            ]
          }
        },
        {
          "key": "announcementColor",
          "label": [
            "Announcement colour",
            "公告颜色"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "required_when": {
            "field": "messageType",
            "value": "announcement"
          },
          "options": [
            "primary",
            "blue",
            "green",
            "orange",
            "purple"
          ],
          "option_labels": {
            "primary": [
              "Channel accent",
              "频道主色"
            ],
            "blue": [
              "Blue",
              "蓝色"
            ],
            "green": [
              "Green",
              "绿色"
            ],
            "orange": [
              "Orange",
              "橙色"
            ],
            "purple": [
              "Purple",
              "紫色"
            ]
          }
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
    "unattended": {
      "account": "button[data-a-target='user-menu-toggle']",
      "submit": "button[data-a-target='chat-send-button']",
      "submit_key": "Enter",
      "result": "a[href*='/chat']",
      "handled_fields": [
        "destination"
      ]
    }
  },
  {
    "id": "mastodon",
    "name": "Mastodon",
    "methods": [
      "browser",
      "api"
    ],
    "credential_provider": "mastodon",
    "credential_kind": "service_account",
    "entry_url": "https://mastodon.social/publish",
    "dynamic_host": true,
    "hosts": [
      "mastodon.social"
    ],
    "preview": {
      "layout": "social",
      "fields": [
        {
          "key": "destination",
          "label": [
            "Instance composer URL",
            "实例编辑页网址"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Post",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 500,
          "transfer": "text",
          "selectors": [
            "textarea.autosuggest-textarea__textarea"
          ],
          "format": "plain"
        },
        {
          "key": "warning",
          "label": [
            "Content warning",
            "内容警告"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input.spoiler-input__input"
          ]
        },
        {
          "key": "visibility",
          "label": [
            "Visibility",
            "可见性"
          ],
          "kind": "select",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "public",
            "private",
            "unlisted"
          ],
          "option_labels": {
            "public": [
              "Public",
              "公开"
            ],
            "private": [
              "Followers only",
              "仅关注者"
            ],
            "unlisted": [
              "Unlisted",
              "不公开列出"
            ]
          }
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
    "unattended": {
      "account": "a[href*='/@'][title]",
      "submit": "button[type='submit']",
      "submit_text": [
        "Publish",
        "Post",
        "发布",
        "嘟文"
      ],
      "result": "a.status__relative-time[href]",
      "handled_fields": [
        "destination"
      ]
    }
  },
  {
    "id": "bluesky",
    "name": "Bluesky",
    "methods": [
      "browser",
      "api"
    ],
    "credential_provider": "bluesky",
    "credential_kind": "service_account",
    "entry_url": "https://bsky.app/intent/compose",
    "dynamic_host": false,
    "hosts": [
      "bsky.app"
    ],
    "preview": {
      "layout": "social",
      "fields": [
        {
          "key": "body",
          "label": [
            "Post",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 300,
          "transfer": "text",
          "selectors": [
            ".tiptap.ProseMirror"
          ],
          "format": "plain"
        },
        {
          "key": "alt",
          "label": [
            "Alternative text",
            "图片替代文本"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "language",
          "label": [
            "Language",
            "语言"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": true,
        "transfer": "guided",
        "max_count": 4,
        "video_alone": true
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
    "unattended": {
      "account": "a[href^='/profile/']",
      "submit": "button",
      "submit_text": [
        "Post",
        "发布"
      ],
      "result": "a[href*='/post/']"
    }
  },
  {
    "id": "lemmy",
    "name": "Lemmy",
    "methods": [
      "browser",
      "api"
    ],
    "credential_provider": "lemmy",
    "credential_kind": "service_account",
    "entry_url": "https://lemmy.world/create_post",
    "dynamic_host": true,
    "hosts": [
      "lemmy.world"
    ],
    "preview": {
      "layout": "discussion",
      "fields": [
        {
          "key": "destination",
          "label": [
            "Instance composer URL",
            "实例编辑页网址"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "community",
          "label": [
            "Community",
            "社区"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": 200,
          "transfer": "text",
          "selectors": [
            "textarea#post-title",
            "input#post-title"
          ]
        },
        {
          "key": "body",
          "label": [
            "Body",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 10000,
          "transfer": "text",
          "selectors": [
            "textarea[id^=\"markdown-textarea-\"]"
          ],
          "format": "markdown"
        },
        {
          "key": "link",
          "label": [
            "Link",
            "链接"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input#post-url"
          ]
        },
        {
          "key": "nsfw",
          "label": [
            "Adult content",
            "成人内容"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "no",
            "yes"
          ],
          "option_labels": {
            "no": [
              "No",
              "否"
            ],
            "yes": [
              "Yes",
              "是"
            ]
          }
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": false,
        "transfer": "guided",
        "no_video": true
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
    "unattended": {
      "account": "a[href*='/u/']",
      "submit": "button[type='submit']",
      "submit_text": [
        "Create",
        "Post",
        "发布"
      ],
      "result": "a[href*='/post/']",
      "lands_on_post": true,
      "handled_fields": [
        "destination"
      ]
    }
  },
  {
    "id": "wrapcast",
    "name": "Farcaster",
    "methods": [
      "browser"
    ],
    "entry_url": "https://farcaster.xyz/",
    "dynamic_host": false,
    "hosts": [
      "farcaster.xyz"
    ],
    "preview": {
      "layout": "social",
      "fields": [
        {
          "key": "body",
          "label": [
            "Cast",
            "动态"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 800,
          "transfer": "text",
          "selectors": [
            "[contenteditable=\"true\"][role=\"textbox\"]"
          ],
          "format": "plain"
        },
        {
          "key": "channel",
          "label": [
            "Channel",
            "频道"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": true,
        "transfer": "guided",
        "no_video": true
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
    "publication_hosts": [
      "farcaster.xyz",
      "warpcast.com"
    ],
    "unattended": {
      "account": "a[href*='/~/profiles/'],a[href^='/'] img[alt*='avatar' i]",
      "submit": "button",
      "submit_text": [
        "Cast",
        "Post",
        "发布"
      ],
      "result": "a[href*='/~/conversations/'],a[href*='/casts/']"
    }
  },
  {
    "id": "telegram",
    "name": "Telegram",
    "methods": [
      "browser"
    ],
    "entry_url": "https://web.telegram.org/a/",
    "dynamic_host": false,
    "hosts": [
      "web.telegram.org"
    ],
    "preview": {
      "layout": "chat",
      "fields": [
        {
          "key": "destination",
          "label": [
            "Web chat URL",
            "网页版聊天网址"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Message",
            "消息"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 4096,
          "transfer": "text",
          "selectors": [
            "[contenteditable=\"true\"][role=\"textbox\"]"
          ],
          "format": "plain"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
    "publication_hosts": [
      "t.me",
      "telegram.me"
    ],
    "unattended": {
      "account": "button[title*='profile' i],button[aria-label*='profile' i]",
      "submit": "button.send",
      "submit_key": "Enter",
      "result": "a[href*='t.me/']",
      "handled_fields": [
        "destination"
      ]
    }
  },
  {
    "id": "nostr",
    "name": "Nostr",
    "methods": [
      "browser"
    ],
    "entry_url": "https://primal.net/",
    "dynamic_host": true,
    "hosts": [
      "primal.net"
    ],
    "preview": {
      "layout": "social",
      "fields": [
        {
          "key": "destination",
          "label": [
            "Web client URL",
            "网页客户端网址"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Note",
            "笔记"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 100000,
          "transfer": "text",
          "selectors": [
            "textarea[placeholder=\"What’s on your mind?\"]"
          ],
          "format": "plain"
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
    "unattended": {
      "account": "a[href*='/p/'],button[aria-label*='profile' i]",
      "submit": "button",
      "submit_text": [
        "Post",
        "Publish",
        "发布"
      ],
      "result": "a[href*='/e/'],a[href*='/note']",
      "handled_fields": [
        "destination"
      ]
    }
  },
  {
    "id": "vk",
    "name": "VK",
    "methods": [
      "browser"
    ],
    "entry_url": "https://vk.com/feed",
    "dynamic_host": false,
    "hosts": [
      "vk.com"
    ],
    "preview": {
      "layout": "social",
      "fields": [
        {
          "key": "destination",
          "label": [
            "Community or profile URL",
            "社区或个人页网址"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Post",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 2048,
          "transfer": "text",
          "selectors": [
            "#post_field"
          ],
          "format": "plain"
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
    "unattended": {
      "account": "a[href^='/id'],a[href*='profile.php']",
      "submit": "button",
      "submit_text": [
        "Publish",
        "Post",
        "Опубликовать",
        "发布"
      ],
      "result": "a[href*='wall']",
      "handled_fields": [
        "destination"
      ]
    }
  },
  {
    "id": "medium",
    "name": "Medium",
    "methods": [
      "browser"
    ],
    "entry_url": "https://medium.com/new-story",
    "dynamic_host": false,
    "hosts": [
      "medium.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "h3[data-testid=\"editorTitleParagraph\"]"
          ],
          "empty_values": [
            "Title"
          ]
        },
        {
          "key": "body",
          "label": [
            "Story",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "div.section-inner .graf--p"
          ],
          "empty_values": [
            "Tell your story…"
          ],
          "format": "rich_text"
        },
        {
          "key": "tags",
          "label": [
            "Topics",
            "主题"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "canonical",
          "label": [
            "Canonical URL",
            "原文地址"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in Medium account, the browser assistant fills the empty title and story, opens Medium's pre-publish settings, submits the final Publish control, and records the post address. Topics, canonical URL and media remain optional and must be left empty for unattended delivery.",
        "Medium 账号已登录时，浏览器助手会填写空白标题和正文，打开预发布设置，提交最终 Publish，并回填帖子地址。主题、原文地址和媒体均为选填；要无人值守发布请保持为空。"
      ]
    },
    "unattended": {
      "account": "button.js-userActions img.avatar-image",
      "account_attribute": "src",
      "open_submit": "button.js-publishButton[data-delayed-action='show-prepublish']",
      "submit": "button.js-publishButton",
      "result": "a[href^='https://medium.com/']",
      "lands_on_post": true
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
    "publication_custom_domain": true
  },
  {
    "id": "devto",
    "name": "DEV Community",
    "methods": [
      "api",
      "browser"
    ],
    "credential_provider": "devto",
    "credential_kind": "service_account",
    "entry_url": "https://dev.to/new",
    "dynamic_host": false,
    "hosts": [
      "dev.to"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": 128,
          "transfer": "text",
          "selectors": [
            "textarea#article-form-title"
          ]
        },
        {
          "key": "body",
          "label": [
            "Markdown",
            "Markdown 正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea#article_body_markdown"
          ],
          "format": "markdown"
        },
        {
          "key": "tags",
          "label": [
            "Tags",
            "标签"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input#tag-input"
          ]
        },
        {
          "key": "canonical",
          "label": [
            "Canonical URL",
            "原文地址"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input#canonicalUrl"
          ]
        },
        {
          "key": "series",
          "label": [
            "Series",
            "系列"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "cover",
          "label": [
            "Cover image",
            "封面图"
          ],
          "kind": "image",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "accept": "image/*"
        },
        {
          "key": "ai_disclosure",
          "label": [
            "AI disclosure",
            "AI 使用声明"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "no_ai",
            "some_ai",
            "fully_autonomous"
          ],
          "option_labels": {
            "no_ai": [
              "No AI",
              "未使用 AI"
            ],
            "some_ai": [
              "Some AI assistance",
              "部分由 AI 协助"
            ],
            "fully_autonomous": [
              "Fully AI-generated",
              "完全由 AI 生成"
            ]
          }
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "unattended": {
      "account": "#user-profile-link-placeholder #first-nav-link",
      "submit": "#editor-actions button.c-btn--primary",
      "lands_on_post": true
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
  },
  {
    "id": "hashnode",
    "name": "Hashnode",
    "methods": [
      "api",
      "browser"
    ],
    "credential_provider": "hashnode",
    "credential_kind": "service_account",
    "entry_url": "https://hashnode.com/draft",
    "dynamic_host": false,
    "hosts": [
      "hashnode.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea[placeholder=\"Article title…\"]",
            "textarea[placeholder=\"Article Title...\"]"
          ],
          "min_length": 6
        },
        {
          "key": "subtitle",
          "label": [
            "Subtitle",
            "副标题"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 10000,
          "transfer": "text",
          "selectors": [
            "div.ProseMirror[contenteditable=\"true\"]",
            "div[contenteditable=\"true\"][data-placeholder*='Type']"
          ],
          "format": "markdown"
        },
        {
          "key": "tags",
          "label": [
            "Tags",
            "标签"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "canonical",
          "label": [
            "Original article URL",
            "原文地址"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "publication",
          "label": [
            "Publication",
            "出版物"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "unattended": {
      "account": "button[class~='group/profile']",
      "account_text": true,
      "open_submit": "button[data-slot='button'][data-variant='outline'][data-size='sm']",
      "submit": "[data-slot='sheet-footer'] button[data-slot='button'][data-variant='default']",
      "lands_on_post": true
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
    "publication_custom_domain": true
  },
  {
    "id": "wordpress",
    "name": "WordPress",
    "methods": [
      "api"
    ],
    "credential_provider": "wordpress-site",
    "credential_kind": "service_account",
    "entry_url": "https://wordpress.org/",
    "dynamic_host": true,
    "hosts": [
      "wordpress.org"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "min_length": 2
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 100000,
          "transfer": "guided",
          "selectors": [],
          "format": "rich_text"
        },
        {
          "key": "excerpt",
          "label": [
            "Excerpt",
            "摘要"
          ],
          "kind": "textarea",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "slug",
          "label": [
            "Slug",
            "网址别名"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "categories",
          "label": [
            "Category IDs",
            "分类 ID"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "tags",
          "label": [
            "Tag IDs",
            "标签 ID"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "status",
          "label": [
            "Publish status",
            "发布状态"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "draft",
            "pending",
            "publish",
            "private"
          ],
          "option_labels": {
            "draft": [
              "Draft",
              "草稿"
            ],
            "pending": [
              "Pending review",
              "待审核"
            ],
            "publish": [
              "Publish publicly",
              "公开发布"
            ],
            "private": [
              "Private",
              "私密"
            ]
          }
        },
        {
          "key": "featured_media",
          "label": [
            "Featured media ID",
            "封面媒体 ID"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user"
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
  },
  {
    "id": "listmonk",
    "name": "Listmonk",
    "methods": [
      "browser"
    ],
    "entry_url": "https://listmonk.app/",
    "dynamic_host": true,
    "hosts": [
      "listmonk.app"
    ],
    "preview": {
      "layout": "newsletter",
      "fields": [
        {
          "key": "destination",
          "label": [
            "Campaign editor URL",
            "邮件编辑页网址"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "title",
          "label": [
            "Campaign name",
            "邮件任务名称"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input[name=\"name\"]"
          ]
        },
        {
          "key": "subject",
          "label": [
            "Subject",
            "邮件主题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input[name=\"subject\"]"
          ]
        },
        {
          "key": "body",
          "label": [
            "Email body",
            "邮件正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "rich_text"
        },
        {
          "key": "preview",
          "label": [
            "Preview text",
            "预览文字"
          ],
          "kind": "textarea",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "list",
          "label": [
            "Recipient lists",
            "收件人列表"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "template",
          "label": [
            "Template",
            "模板"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "sender",
          "label": [
            "From address",
            "发件地址"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
    "unattended": {
      "account": "a[href$='/admin/users/profile'],button[aria-label*='user' i]",
      "open_submit": "button",
      "open_submit_text": [
        "Start campaign",
        "Send",
        "发送"
      ],
      "submit": "button",
      "submit_text": [
        "Start",
        "Send",
        "Confirm",
        "确认发送"
      ],
      "result": "a[href*='/admin/campaigns/']",
      "handled_fields": [
        "destination"
      ]
    }
  },
  {
    "id": "moltbook",
    "name": "Moltbook",
    "methods": [
      "browser"
    ],
    "entry_url": "https://www.moltbook.com/",
    "dynamic_host": false,
    "hosts": [
      "moltbook.com"
    ],
    "preview": {
      "layout": "discussion",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input[name=\"title\"]"
          ]
        },
        {
          "key": "body",
          "label": [
            "Content",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 300,
          "transfer": "text",
          "selectors": [
            "textarea[name=\"content\"]"
          ],
          "format": "markdown"
        },
        {
          "key": "community",
          "label": [
            "Submolt",
            "社区"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
    "unattended": {
      "account": "a[href*='/profile/'],button[aria-label*='profile' i]",
      "submit": "button[type='submit']",
      "submit_text": [
        "Submit",
        "Post",
        "发布"
      ],
      "result": "a[href*='/post/']"
    }
  },
  {
    "id": "whop",
    "name": "Whop",
    "methods": [
      "browser"
    ],
    "entry_url": "https://whop.com/",
    "dynamic_host": false,
    "hosts": [
      "whop.com"
    ],
    "preview": {
      "layout": "discussion",
      "fields": [
        {
          "key": "destination",
          "label": [
            "Community URL",
            "社区网址"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Content",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 50000,
          "transfer": "text",
          "selectors": [
            "[contenteditable=\"true\"][data-lexical-editor=\"true\"]"
          ],
          "format": "markdown"
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
    "unattended": {
      "account": "button[aria-label*='account' i],a[href*='/settings/profile']",
      "submit": "button",
      "submit_text": [
        "Post",
        "Publish",
        "发布"
      ],
      "result": "a[href*='/posts/']",
      "handled_fields": [
        "destination"
      ]
    }
  },
  {
    "id": "skool",
    "name": "Skool",
    "methods": [
      "browser"
    ],
    "entry_url": "https://www.skool.com/",
    "dynamic_host": false,
    "hosts": [
      "skool.com"
    ],
    "preview": {
      "layout": "discussion",
      "fields": [
        {
          "key": "destination",
          "label": [
            "Group URL",
            "小组网址"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input[placeholder=\"Title\"]"
          ]
        },
        {
          "key": "body",
          "label": [
            "Post",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 5000,
          "transfer": "text",
          "selectors": [
            "[contenteditable=\"true\"][data-placeholder=\"Write something...\"]"
          ],
          "format": "markdown"
        },
        {
          "key": "category",
          "label": [
            "Category",
            "分类"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
    "unattended": {
      "account": "button[aria-label*='profile' i],a[href*='/settings']",
      "submit": "button",
      "submit_text": [
        "Post",
        "Publish",
        "发布"
      ],
      "result": "a[href*='?p='],a[href*='/post/']",
      "handled_fields": [
        "destination"
      ]
    }
  },
  {
    "id": "mewe",
    "name": "MeWe",
    "methods": [
      "browser"
    ],
    "entry_url": "https://mewe.com/myworld",
    "dynamic_host": false,
    "hosts": [
      "mewe.com"
    ],
    "preview": {
      "layout": "social",
      "fields": [
        {
          "key": "destination",
          "label": [
            "Group or profile URL",
            "群组或个人页网址"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Post",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 63206,
          "transfer": "text",
          "selectors": [
            "[contenteditable=\"true\"][data-placeholder=\"Tell your contacts what’s happening\"]"
          ],
          "format": "plain"
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
    "unattended": {
      "account": "a[href*='/i/my-profile'],button[aria-label*='profile' i]",
      "submit": "button",
      "submit_text": [
        "Post",
        "发布"
      ],
      "result": "a[href*='/posts/']",
      "handled_fields": [
        "destination"
      ]
    }
  },
  {
    "id": "tumblr",
    "name": "Tumblr",
    "methods": [
      "browser"
    ],
    "entry_url": "https://www.tumblr.com/new/text",
    "dynamic_host": false,
    "hosts": [
      "tumblr.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "[data-type=\"core/heading\"][contenteditable=\"true\"]"
          ]
        },
        {
          "key": "body",
          "label": [
            "Post",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 32768,
          "transfer": "text",
          "selectors": [
            "[data-type=\"core/paragraph\"][contenteditable=\"true\"]"
          ],
          "format": "rich_text"
        },
        {
          "key": "tags",
          "label": [
            "Tags",
            "标签"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea[placeholder=\"#add tags\"]"
          ]
        },
        {
          "key": "blog",
          "label": [
            "Blog",
            "博客"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "slug",
          "label": [
            "Custom URL",
            "自定义网址"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": true,
        "transfer": "guided",
        "max_count": 30
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
    "formats": [
      {
        "id": "text",
        "label": [
          "Text",
          "文章"
        ]
      },
      {
        "id": "link",
        "label": [
          "Link",
          "链接"
        ],
        "entry_url": "https://www.tumblr.com/new/link",
        "preview": {
          "layout": "social",
          "fields": [
            {
              "key": "link",
              "label": [
                "Link",
                "链接"
              ],
              "kind": "url",
              "required": true,
              "max_length": null,
              "transfer": "text",
              "selectors": [
                "input[placeholder=\"Type or paste link\"]"
              ]
            },
            {
              "key": "tags",
              "label": [
                "Tags",
                "标签"
              ],
              "kind": "text",
              "required": false,
              "max_length": null,
              "transfer": "text",
              "selectors": [
                "textarea[placeholder=\"#add tags\"]"
              ]
            }
          ],
          "media": null
        },
        "browser": {
          "instructions": [
            "This flow posts a link. Paste the address and Tumblr fetches the title and summary itself; there is no body until it has. Unattended publishing is not available.",
            "当前为链接贴:填入地址后由 Tumblr 自己抓标题和摘要，抓到之前没有正文框。暂不支持无人值守发布。"
          ]
        }
      },
      {
        "id": "photo",
        "label": [
          "Photo",
          "图片"
        ],
        "entry_url": "https://www.tumblr.com/new/photo",
        "preview": {
          "layout": "gallery",
          "fields": [
            {
              "key": "body",
              "label": [
                "Body",
                "正文"
              ],
              "kind": "textarea",
              "required": true,
              "max_length": null,
              "transfer": "text",
              "selectors": [
                "[data-type=\"core/paragraph\"][contenteditable=\"true\"]"
              ]
            },
            {
              "key": "tags",
              "label": [
                "Tags",
                "标签"
              ],
              "kind": "text",
              "required": false,
              "max_length": null,
              "transfer": "text",
              "selectors": [
                "textarea[placeholder=\"#add tags\"]"
              ]
            }
          ],
          "media": {
            "accept": "image/*",
            "required": true,
            "multiple": true,
            "transfer": "guided"
          }
        },
        "browser": {
          "instructions": [
            "This flow posts pictures with a caption and no title. Upload first; the caption is the paragraph block under it.",
            "当前为图片贴:先上传图片，说明文字是下面那个段落块，没有标题。"
          ]
        }
      },
      {
        "id": "video",
        "label": [
          "Video",
          "视频"
        ],
        "entry_url": "https://www.tumblr.com/new/video",
        "preview": {
          "layout": "video",
          "fields": [
            {
              "key": "body",
              "label": [
                "Body",
                "正文"
              ],
              "kind": "textarea",
              "required": true,
              "max_length": null,
              "transfer": "text",
              "selectors": [
                "[data-type=\"core/paragraph\"][contenteditable=\"true\"]"
              ]
            },
            {
              "key": "tags",
              "label": [
                "Tags",
                "标签"
              ],
              "kind": "text",
              "required": false,
              "max_length": null,
              "transfer": "text",
              "selectors": [
                "textarea[placeholder=\"#add tags\"]"
              ]
            }
          ],
          "media": {
            "accept": "video/mp4,video/quicktime",
            "required": true,
            "multiple": false,
            "transfer": "guided"
          }
        },
        "browser": {
          "instructions": [
            "This flow posts one video with a caption and no title. Tumblr takes MP4 and QuickTime only.",
            "当前为视频贴:一段视频加说明文字，没有标题。Tumblr 只接受 MP4 和 QuickTime。"
          ]
        }
      }
    ],
    "unattended": {
      "account": "a[href*='/blog/'],button[aria-label*='account' i]",
      "submit": "button",
      "submit_text": [
        "Post now",
        "Post",
        "发布"
      ],
      "result": "a[href*='/post/']"
    }
  },
  {
    "id": "wechat",
    "name": "微信公众号",
    "entry_url": "https://mp.weixin.qq.com/",
    "hosts": [
      "mp.weixin.qq.com"
    ],
    "methods": [
      "browser"
    ],
    "dynamic_host": false,
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": 64,
          "transfer": "text",
          "selectors": [
            "#title",
            "textarea[placeholder=\"请在这里输入标题\"]"
          ]
        },
        {
          "key": "body",
          "label": [
            "Body",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            ".mock-iframe-body .ProseMirror[contenteditable=\"true\"]",
            "#ueditor_0 body[contenteditable=\"true\"]",
            "body.view[contenteditable=\"true\"]"
          ],
          "format": "rich_text",
          "empty_values": [
            "从这里开始写正文"
          ]
        },
        {
          "key": "author",
          "label": [
            "Author",
            "作者"
          ],
          "kind": "text",
          "required": false,
          "max_length": 8,
          "transfer": "text",
          "selectors": [
            "#author"
          ]
        },
        {
          "key": "summary",
          "label": [
            "Summary",
            "摘要"
          ],
          "kind": "textarea",
          "required": false,
          "max_length": 120,
          "transfer": "text",
          "selectors": [
            "#js_description",
            "#digest"
          ]
        },
        {
          "key": "canonical",
          "label": [
            "Original link",
            "原文链接"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input[name=\"source_url\"]",
            "#js_content_source_url"
          ]
        },
        {
          "key": "cover",
          "label": [
            "Cover",
            "封面"
          ],
          "kind": "image",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "accept": "image/*"
        },
        {
          "key": "original",
          "label": [
            "Originality",
            "原创声明"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "none",
            "original"
          ],
          "option_labels": {
            "none": [
              "Not declared",
              "未声明"
            ],
            "original": [
              "Declare as original",
              "声明原创"
            ]
          }
        },
        {
          "key": "source",
          "label": [
            "Creation source",
            "创作来源"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "collection",
          "label": [
            "Collection",
            "合集"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "recommend",
          "label": [
            "Platform recommendation",
            "平台推荐"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "on",
            "off"
          ],
          "option_labels": {
            "on": [
              "On — may appear in 看一看",
              "开启 — 可能被推荐至看一看"
            ],
            "off": [
              "Off — pushed to followers only",
              "不开启 — 仅推送给关注者"
            ]
          }
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "upstream_ref": "ondit-native",
    "unattended": {
      "account": "a[href*='settingpage'],.weui-desktop-account__nickname",
      "frame_account": true,
      "open_submit": "button",
      "open_submit_text": [
        "发表",
        "群发"
      ],
      "submit": "button",
      "submit_text": [
        "确定",
        "继续发表",
        "群发"
      ],
      "result": "a[href*='mp.weixin.qq.com/s/']"
    }
  },
  {
    "id": "zhihu",
    "name": "知乎",
    "entry_url": "https://zhuanlan.zhihu.com/write",
    "hosts": [
      "zhuanlan.zhihu.com"
    ],
    "publication_hosts": [
      "www.zhihu.com"
    ],
    "methods": [
      "browser"
    ],
    "dynamic_host": false,
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": 100,
          "transfer": "text",
          "selectors": [
            "textarea[placeholder=\"请输入标题（最多 100 个字）\"]",
            ".WriteIndex-titleInput textarea"
          ]
        },
        {
          "key": "body",
          "label": [
            "Body",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            ".public-DraftEditor-content[contenteditable=\"true\"]",
            ".ProseMirror[contenteditable=\"true\"]"
          ],
          "format": "rich_text"
        },
        {
          "key": "cover",
          "label": [
            "Cover",
            "文章封面"
          ],
          "kind": "image",
          "accept": "image/jpeg,image/png",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "question",
          "label": [
            "Submit to question",
            "投稿至问题（选填）"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "declaration",
          "label": [
            "Creator declaration",
            "创作声明"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "ai_assisted",
            "none",
            "spoiler",
            "medical",
            "fiction",
            "finance"
          ],
          "option_labels": {
            "ai_assisted": [
              "Includes AI-assisted writing",
              "包含 AI 辅助创作"
            ],
            "none": [
              "No declaration",
              "无声明"
            ],
            "spoiler": [
              "Contains spoilers",
              "包含剧透"
            ],
            "medical": [
              "Contains medical advice",
              "包含医疗建议"
            ],
            "fiction": [
              "Fiction",
              "虚构创作"
            ],
            "finance": [
              "Contains financial content",
              "包含理财内容"
            ]
          }
        },
        {
          "key": "topics",
          "label": [
            "Topics",
            "文章话题"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "source",
          "label": [
            "Content source",
            "内容来源（新闻类必填）"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in Zhihu account, the browser assistant fills the title and body, opens Publish settings when needed, publishes, and records the article URL. Cover, question, creator declaration, topics and source remain optional and must be left empty for unattended delivery.",
        "知乎账号已登录时，浏览器助手会填写标题和正文，必要时打开发布设置后发布，并回填文章地址。封面、投稿问题、创作声明、话题和来源均为选填；要无人值守发布请保持为空。"
      ]
    },
    "unattended": {
      "account": "button.AppHeader-profileEntry img.AppHeader-profileAvatar",
      "account_attribute": "src",
      "open_submit": "button",
      "submit": "button",
      "result": "a[href*='/p/']",
      "lands_on_post": true
    },
    "upstream_ref": "ondit-native"
  },
  {
    "id": "xiaohongshu",
    "name": "小红书",
    "entry_url": "https://creator.xiaohongshu.com/publish/publish?from=homepage&target=image",
    "hosts": [
      "creator.xiaohongshu.com"
    ],
    "publication_hosts": [
      "www.xiaohongshu.com",
      "xiaohongshu.com",
      "xhslink.com"
    ],
    "methods": [
      "browser"
    ],
    "dynamic_host": false,
    "preview": {
      "layout": "social",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": 20,
          "transfer": "text",
          "selectors": [
            "input[placeholder*=\"填写标题\"]"
          ]
        },
        {
          "key": "body",
          "label": [
            "Body",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 1000,
          "transfer": "text",
          "selectors": [
            ".tiptap[contenteditable=\"true\"]",
            ".ql-editor[contenteditable=\"true\"]"
          ],
          "format": "plain"
        },
        {
          "key": "topics",
          "label": [
            "Topics",
            "话题（在平台选择）"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "location",
          "label": [
            "Location",
            "地点（选填）"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "declaration",
          "label": [
            "Content declaration",
            "原创声明"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "collection",
          "label": [
            "Collection",
            "加入合集"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*",
        "required": true,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "formats": [
      {
        "id": "image",
        "label": [
          "Image note",
          "图文"
        ]
      },
      {
        "id": "video",
        "label": [
          "Video",
          "视频"
        ],
        "entry_url": "https://creator.xiaohongshu.com/publish/publish?from=homepage&target=video",
        "preview": {
          "layout": "video",
          "media": {
            "accept": "video/*",
            "required": true,
            "multiple": false,
            "transfer": "guided"
          }
        },
        "browser": {
          "instructions": [
            "This flow creates a video note. Upload one video first; once it has processed, continue filling the title and body with the assistant. Choose the cover and review topics and visibility before publishing. Unattended publishing is not available.",
            "当前为视频笔记。先上传一个视频，处理完成后在助手中继续填入标题和正文；封面、话题及可见范围在平台核对后发布。暂不支持无人值守发布。"
          ]
        }
      },
      {
        "id": "article",
        "label": [
          "Long article",
          "长文"
        ],
        "entry_url": "https://creator.xiaohongshu.com/publish/publish?from=homepage&target=article",
        "preview": {
          "layout": "article",
          "fields": [
            {
              "key": "title",
              "label": [
                "Title",
                "标题"
              ],
              "kind": "text",
              "required": true,
              "max_length": 64,
              "transfer": "text",
              "selectors": [
                "textarea[placeholder=\"输入标题\"]"
              ]
            },
            {
              "key": "body",
              "label": [
                "Body",
                "正文"
              ],
              "kind": "textarea",
              "required": true,
              "max_length": null,
              "transfer": "text",
              "selectors": [
                ".tiptap.ProseMirror"
              ],
              "format": "rich_text",
              "flattens_links": true
            }
          ],
          "media": null
        },
        "browser": {
          "instructions": [
            "This flow opens the long-article editor, which is reached from the long-form page rather than by address: open 写长文 and press 新的创作. Its editor keeps headings and drops links and bold, so the citation has to be a bare address in the text. Unattended publishing is not available.",
            "当前为长文编辑器。它不是一个可以直接打开的地址：在「写长文」页点「新的创作」才进得去。编辑器保留小标题，但会丢掉链接和加粗，所以回链要写成正文里的纯地址。暂不支持无人值守发布。"
          ]
        }
      }
    ],
    "upstream_ref": "ondit-native",
    "unattended": {
      "account": "a[href*='/user/profile/'],.user-name",
      "submit": "button",
      "submit_text": [
        "发布",
        "Publish"
      ],
      "result": "a[href*='/explore/'],a[href*='/discovery/item/']"
    }
  },
  {
    "id": "douyin",
    "name": "抖音",
    "entry_url": "https://creator.douyin.com/creator-micro/content/upload",
    "hosts": [
      "creator.douyin.com"
    ],
    "publication_hosts": [
      "www.douyin.com",
      "v.douyin.com"
    ],
    "methods": [
      "browser"
    ],
    "dynamic_host": false,
    "preview": {
      "layout": "video",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": 30,
          "transfer": "text",
          "selectors": [
            "input[placeholder*=\"填写作品标题\"]"
          ]
        },
        {
          "key": "body",
          "label": [
            "Description",
            "作品描述"
          ],
          "kind": "textarea",
          "required": false,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "div.zone-container[contenteditable=\"true\"]"
          ]
        },
        {
          "key": "topics",
          "label": [
            "Topics",
            "话题（在平台选择）"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "location",
          "label": [
            "Location",
            "地点（选填）"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "video/*",
        "required": true,
        "multiple": false,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "upstream_ref": "ondit-native",
    "formats": [
      {
        "id": "video",
        "label": [
          "Video",
          "视频"
        ]
      },
      {
        "id": "article",
        "label": [
          "Article",
          "文章"
        ],
        "entry_url": "https://creator.douyin.com/creator-micro/content/post/article?media_type=article&type=new",
        "preview": {
          "layout": "article",
          "fields": [
            {
              "key": "title",
              "label": [
                "Title",
                "文章标题"
              ],
              "kind": "text",
              "required": true,
              "max_length": 30,
              "transfer": "text",
              "selectors": [
                "input[placeholder^=\"请输入文章标题\"]"
              ]
            },
            {
              "key": "summary",
              "label": [
                "Summary",
                "文章摘要"
              ],
              "kind": "text",
              "required": false,
              "max_length": 30,
              "transfer": "text",
              "selectors": [
                "input[placeholder^=\"添加内容摘要\"]"
              ]
            },
            {
              "key": "body",
              "label": [
                "Body",
                "文章正文"
              ],
              "kind": "textarea",
              "required": true,
              "max_length": 20000,
              "transfer": "text",
              "selectors": [
                "[contenteditable=\"true\"][role=\"textbox\"]"
              ],
              "format": "rich_text",
              "flattens_links": true
            },
            {
              "key": "cover",
              "label": [
                "Cover",
                "封面"
              ],
              "kind": "image",
              "required": true,
              "max_length": null,
              "transfer": "guided",
              "selectors": [],
              "accept": "image/*"
            },
            {
              "key": "header_image",
              "label": [
                "Header image",
                "文章头图"
              ],
              "kind": "image",
              "required": false,
              "max_length": null,
              "transfer": "guided",
              "selectors": [],
              "accept": "image/*"
            },
            {
              "key": "topics",
              "label": [
                "Topics",
                "话题"
              ],
              "kind": "text",
              "required": false,
              "max_length": null,
              "transfer": "guided",
              "selectors": []
            },
            {
              "key": "visibility",
              "label": [
                "Who can see it",
                "谁可以看"
              ],
              "kind": "select",
              "required": true,
              "max_length": null,
              "transfer": "guided",
              "selectors": [],
              "options": [
                "public",
                "friends",
                "private"
              ],
              "option_labels": {
                "public": [
                  "Public",
                  "公开"
                ],
                "friends": [
                  "Friends",
                  "好友可见"
                ],
                "private": [
                  "Only me",
                  "仅自己可见"
                ]
              }
            }
          ],
          "media": null
        },
        "browser": {
          "instructions": [
            "This flow opens Douyin's article editor, which takes no upload: the title, summary and body fill straight away. A cover is required before it will publish, and the header image, topics and who may see it are set on the platform. Unattended publishing is not available. The editor drops a link and writes \"该文本类型暂不支持，请替换素材\" into the body where it was, so the citation has to be a bare address in the text rather than a link, and that line is removed before publishing.",
            "当前为抖音文章，无需上传：标题、摘要与正文可直接填入。发布前必须在平台设置封面；头图、话题与可见范围也在平台核对。暂不支持无人值守发布。该编辑器会丢掉链接，并在原处写入「该文本类型暂不支持，请替换素材」，所以回链要写成正文里的纯地址，并在发布前删掉这句提示。"
          ]
        }
      }
    ],
    "unattended": {
      "account": "a[href*='/creator-micro/home'],.semi-avatar",
      "submit": "button",
      "submit_text": [
        "发布",
        "Publish"
      ],
      "result": "a[href*='/video/'],a[href*='/creator-micro/content/manage']"
    }
  },
  {
    "id": "bilibili",
    "name": "哔哩哔哩",
    "entry_url": "https://member.bilibili.com/platform/upload/video/frame",
    "hosts": [
      "member.bilibili.com"
    ],
    "publication_hosts": [
      "www.bilibili.com",
      "b23.tv"
    ],
    "methods": [
      "browser"
    ],
    "dynamic_host": false,
    "preview": {
      "layout": "video",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": 80,
          "transfer": "text",
          "selectors": [
            ".video-title input",
            "input[placeholder=\"请输入稿件标题\"]"
          ]
        },
        {
          "key": "body",
          "label": [
            "Description",
            "视频简介"
          ],
          "kind": "textarea",
          "required": false,
          "max_length": 2000,
          "transfer": "text",
          "selectors": [
            ".desc-text-wrp .ql-editor[contenteditable=\"true\"]",
            ".ql-editor[contenteditable=\"true\"]"
          ]
        },
        {
          "key": "category",
          "label": [
            "Category",
            "分区（在平台选择）"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "tags",
          "label": [
            "Tags",
            "标签（在平台选择）"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "copyright",
          "label": [
            "Copyright",
            "稿件类型"
          ],
          "kind": "select",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "original",
            "repost"
          ],
          "option_labels": {
            "original": [
              "Original",
              "自制"
            ],
            "repost": [
              "Repost",
              "转载"
            ]
          }
        },
        {
          "key": "source",
          "label": [
            "Source URL for reposts",
            "转载来源（转载时必填）"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "required_when": {
            "field": "copyright",
            "value": "repost"
          }
        }
      ],
      "media": {
        "accept": "video/*",
        "required": true,
        "multiple": false,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "upstream_ref": "ondit-native",
    "formats": [
      {
        "id": "video",
        "label": [
          "Video",
          "视频"
        ]
      },
      {
        "id": "article",
        "label": [
          "Column",
          "专栏"
        ],
        "entry_url": "https://member.bilibili.com/york/read-editor",
        "preview": {
          "layout": "article",
          "fields": [
            {
              "key": "title",
              "label": [
                "Title",
                "标题"
              ],
              "kind": "text",
              "required": true,
              "max_length": null,
              "transfer": "text",
              "selectors": [
                "textarea.title-input__inner"
              ]
            },
            {
              "key": "body",
              "label": [
                "Body",
                "正文"
              ],
              "kind": "textarea",
              "required": true,
              "max_length": 100000,
              "transfer": "text",
              "selectors": [
                ".tiptap.ProseMirror.eva3-editor"
              ],
              "format": "rich_text",
              "flattens_links": true
            },
            {
              "key": "cover",
              "label": [
                "Cover",
                "自定义封面"
              ],
              "kind": "image",
              "required": false,
              "max_length": null,
              "transfer": "guided",
              "selectors": [],
              "accept": "image/*"
            },
            {
              "key": "visibility",
              "label": [
                "Who can see it",
                "可见范围"
              ],
              "kind": "select",
              "required": true,
              "max_length": null,
              "transfer": "guided",
              "selectors": [],
              "options": [
                "all",
                "private"
              ],
              "option_labels": {
                "all": [
                  "Everyone",
                  "所有人可见"
                ],
                "private": [
                  "Only me",
                  "仅自己可见"
                ]
              }
            },
            {
              "key": "original",
              "label": [
                "Declare as original",
                "创作声明"
              ],
              "kind": "select",
              "required": false,
              "max_length": null,
              "transfer": "guided",
              "selectors": [],
              "options": [
                "no",
                "yes"
              ],
              "option_labels": {
                "no": [
                  "No",
                  "不声明"
                ],
                "yes": [
                  "Original, no reposting",
                  "原创，禁止转载"
                ]
              }
            },
            {
              "key": "ai_assisted",
              "label": [
                "AI-assisted",
                "AI辅助创作声明"
              ],
              "kind": "select",
              "required": false,
              "max_length": null,
              "transfer": "guided",
              "selectors": [],
              "options": [
                "no",
                "yes"
              ],
              "option_labels": {
                "no": [
                  "No",
                  "否"
                ],
                "yes": [
                  "Yes",
                  "是"
                ]
              }
            },
            {
              "key": "topics",
              "label": [
                "Topics",
                "话题"
              ],
              "kind": "text",
              "required": false,
              "max_length": null,
              "transfer": "guided",
              "selectors": []
            },
            {
              "key": "collection",
              "label": [
                "Collection",
                "文集"
              ],
              "kind": "text",
              "required": false,
              "max_length": null,
              "transfer": "guided",
              "selectors": []
            }
          ],
          "media": null
        },
        "browser": {
          "instructions": [
            "This flow opens Bilibili's column editor, which takes no upload: the title and body fill straight away. The cover, who may see it, the originality and AI declarations, topics and the collection are set on the platform. Unattended publishing is not available. The editor keeps the words and drops every link, so the citation has to be a bare address in the text.",
            "当前为 B 站专栏，无需上传：标题与正文可直接填入。封面、可见范围、原创与 AI 辅助声明、话题与文集在平台核对后发布。暂不支持无人值守发布。该编辑器保留文字但丢掉所有链接，所以回链要写成正文里的纯地址。"
          ]
        }
      }
    ],
    "unattended": {
      "account": "a[href*='space.bilibili.com/'],.header-avatar-wrap",
      "submit": "button",
      "submit_text": [
        "立即投稿",
        "发布",
        "Publish"
      ],
      "result": "a[href*='bilibili.com/video/'],a[href*='bilibili.com/read/']"
    }
  },
  {
    "id": "weibo",
    "name": "微博",
    "entry_url": "https://weibo.com/manage/schedule?type=0&hasnav=0",
    "hosts": [
      "weibo.com"
    ],
    "methods": [
      "browser"
    ],
    "dynamic_host": false,
    "preview": {
      "layout": "social",
      "fields": [
        {
          "key": "body",
          "label": [
            "Post",
            "微博正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea[placeholder=\"有什么新鲜事想分享给大家？\"]"
          ],
          "format": "plain"
        },
        {
          "key": "topics",
          "label": [
            "Topics",
            "话题"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "audience",
          "label": [
            "Audience",
            "可见范围"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "declaration",
          "label": [
            "Content declaration",
            "内容声明"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "none",
            "ai_generated",
            "fiction"
          ],
          "option_labels": {
            "none": [
              "None",
              "无"
            ],
            "ai_generated": [
              "Contains AI-generated content",
              "含AI生成内容"
            ],
            "fiction": [
              "Fiction",
              "虚构内容"
            ]
          }
        }
      ],
      "media": {
        "accept": "image/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in enterprise Weibo account, the browser assistant fills the scheduled post and sends it. Images, topics, audience and declarations remain optional and must be left empty for unattended delivery.",
        "企业微博账号已登录时，浏览器助手会填写定时微博并发送。图片、话题、可见范围和声明均为选填；要无人值守发送请保持为空。"
      ]
    },
    "unattended": {
      "account": ".userName",
      "account_text": true,
      "frame_account": true,
      "open_editor": "button",
      "open_editor_text": [
        "发布定时微博"
      ],
      "submit": "button",
      "result": "a[href*='/status/']"
    },
    "upstream_ref": "ondit-native"
  },
  {
    "id": "toutiao",
    "name": "今日头条",
    "entry_url": "https://mp.toutiao.com/profile_v4/graphic/publish",
    "hosts": [
      "mp.toutiao.com"
    ],
    "methods": [
      "browser"
    ],
    "dynamic_host": false,
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea[placeholder^=\"请输入文章标题\"]"
          ]
        },
        {
          "key": "body",
          "label": [
            "Body",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            ".ProseMirror[contenteditable=\"true\"]",
            ".ql-editor[contenteditable=\"true\"]"
          ],
          "format": "rich_text",
          "empty_values": [
            "请输入正文"
          ],
          "flattens_links": true
        },
        {
          "key": "declaration",
          "label": [
            "Content declaration",
            "作品声明"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "none",
            "web_sourced",
            "site_quoted",
            "opinion",
            "ai_quoted",
            "fiction",
            "investment",
            "health"
          ],
          "option_labels": {
            "none": [
              "None",
              "无"
            ],
            "web_sourced": [
              "Sourced from the web",
              "取材网络"
            ],
            "site_quoted": [
              "Quoted from this site",
              "引用站内"
            ],
            "opinion": [
              "Personal opinion",
              "个人观点，仅供参考"
            ],
            "ai_quoted": [
              "Quotes AI output",
              "引用AI"
            ],
            "fiction": [
              "Fiction",
              "虚构演绎，故事经历"
            ],
            "investment": [
              "Investment view",
              "投资观点，仅供参考"
            ],
            "health": [
              "Health or medical",
              "健康医疗分享，仅供参考"
            ]
          }
        },
        {
          "key": "cover",
          "label": [
            "Cover",
            "封面"
          ],
          "kind": "image",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "accept": "image/*"
        },
        {
          "key": "cover_mode",
          "label": [
            "Cover layout",
            "展示封面"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "one",
            "three",
            "none"
          ],
          "option_labels": {
            "one": [
              "One image",
              "单图"
            ],
            "three": [
              "Three images",
              "三图"
            ],
            "none": [
              "No cover",
              "无封面"
            ]
          }
        },
        {
          "key": "first_publish",
          "label": [
            "Declare first publication",
            "声明首发"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "no",
            "yes"
          ],
          "option_labels": {
            "no": [
              "No",
              "不声明"
            ],
            "yes": [
              "Toutiao first",
              "头条首发"
            ]
          }
        },
        {
          "key": "location",
          "label": [
            "Location",
            "添加位置"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "collection",
          "label": [
            "Collection",
            "合集"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "live_verified",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "This flow creates a Toutiao article. With a signed-in account, a scheduled task fills the title and body, opens the platform's preview sheet, submits its final Publish action, and saves the article address back to Ondit. Cover, declaration, location and collection remain optional: leave them empty for automated delivery, or complete them on the platform before scheduling. The editor drops pasted links, so review any citation that must remain a link.",
        "此入口发布头条号图文。账号已登录时，定时任务会填入标题和正文，打开平台的预览发布面板，提交最终发布，并把文章地址回填到 Ondit。封面、声明、位置和合集是选填项：要无人值守发布请保持为空；如需填写，请先在平台完成后再安排。编辑器会把粘贴链接变成纯文字，必须保留的引用链接请核对。"
      ]
    },
    "unattended": {
      "account": ".user-panel a[href*='/c/user/']",
      "open_submit": "button.publish-btn.publish-btn-last",
      "submit": "[role='dialog'] button",
      "result": "a[href*='/article/']",
      "lands_on_post": true
    },
    "upstream_ref": "ondit-native",
    "publication_hosts": [
      "toutiao.com"
    ]
  },
  {
    "id": "baijiahao",
    "name": "百家号",
    "entry_url": "https://baijiahao.baidu.com/builder/rc/edit?type=news",
    "hosts": [
      "baijiahao.baidu.com"
    ],
    "methods": [
      "browser"
    ],
    "dynamic_host": false,
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            ".input-box [contenteditable=\"true\"][data-lexical-editor=\"true\"]",
            "[contenteditable=\"true\"][data-lexical-editor=\"true\"]"
          ]
        },
        {
          "key": "body",
          "label": [
            "Body",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "body.view[contenteditable=\"true\"]",
            ".ProseMirror[contenteditable=\"true\"]"
          ],
          "format": "rich_text",
          "flattens_links": true
        },
        {
          "key": "category",
          "label": [
            "Category",
            "分类"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "declaration",
          "label": [
            "Creator declaration",
            "创作声明"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "none",
            "ai_generated"
          ],
          "option_labels": {
            "none": [
              "None",
              "无"
            ],
            "ai_generated": [
              "Contains AI-generated content",
              "采用AI生成内容"
            ]
          }
        },
        {
          "key": "cover",
          "label": [
            "Cover",
            "封面"
          ],
          "kind": "image",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "accept": "image/*"
        },
        {
          "key": "cover_mode",
          "label": [
            "Cover layout",
            "设置封面"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "one",
            "three"
          ],
          "option_labels": {
            "one": [
              "One image",
              "单图"
            ],
            "three": [
              "Three images",
              "三图"
            ]
          }
        },
        {
          "key": "source",
          "label": [
            "Source note",
            "来源说明"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "upstream_ref": "ondit-native",
    "publication_hosts": [
      "baijiahao.baidu.com"
    ],
    "formats": [
      {
        "id": "article",
        "label": [
          "Article",
          "图文"
        ]
      },
      {
        "id": "moment",
        "label": [
          "Moment",
          "动态"
        ],
        "entry_url": "https://baijiahao.baidu.com/builder/rc/edit?type=events",
        "preview": {
          "layout": "social",
          "fields": [
            {
              "key": "body",
              "label": [
                "Body",
                "作品描述"
              ],
              "kind": "textarea",
              "required": true,
              "max_length": 2000,
              "transfer": "guided",
              "selectors": []
            },
            {
              "key": "topics",
              "label": [
                "Topics",
                "话题"
              ],
              "kind": "text",
              "required": false,
              "max_length": null,
              "transfer": "guided",
              "selectors": []
            },
            {
              "key": "location",
              "label": [
                "Location",
                "添加地点"
              ],
              "kind": "text",
              "required": false,
              "max_length": null,
              "transfer": "guided",
              "selectors": []
            },
            {
              "key": "declaration",
              "label": [
                "Creator declaration",
                "创作声明"
              ],
              "kind": "select",
              "required": false,
              "max_length": null,
              "transfer": "guided",
              "selectors": [],
              "options": [
                "none",
                "ai_generated"
              ],
              "option_labels": {
                "none": [
                  "None",
                  "无"
                ],
                "ai_generated": [
                  "Contains AI-generated content",
                  "采用AI生成内容"
                ]
              }
            }
          ],
          "media": {
            "accept": "image/*",
            "required": false,
            "multiple": true,
            "transfer": "guided"
          }
        },
        "browser": {
          "instructions": [
            "This flow posts a moment: a short body of up to 2,000 characters with optional pictures. There is no title. Topics, location and the creator declaration are set on the platform. Unattended publishing is not available.",
            "当前为动态：一段不超过 2000 字的正文，可选配图，没有标题。话题、地点与创作声明在平台核对后发布。暂不支持无人值守发布。"
          ]
        }
      }
    ],
    "unattended": {
      "account": "img[alt='头像']",
      "account_attribute": "src",
      "frame_account": true,
      "submit": "button",
      "submit_text": [
        "发布",
        "Publish"
      ],
      "result": "a[href*='baijiahao.baidu.com/s?id=']"
    }
  },
  {
    "id": "kuaishou",
    "name": "快手",
    "entry_url": "https://cp.kuaishou.com/article/publish/video",
    "hosts": [
      "cp.kuaishou.com"
    ],
    "methods": [
      "browser"
    ],
    "dynamic_host": false,
    "preview": {
      "layout": "video",
      "fields": [
        {
          "key": "body",
          "label": [
            "Video description",
            "视频描述"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "div[contenteditable=\"true\"]"
          ],
          "format": "plain"
        },
        {
          "key": "topics",
          "label": [
            "Topics",
            "话题"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "audience",
          "label": [
            "Who can see it",
            "查看权限"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "all",
            "friends",
            "private"
          ],
          "option_labels": {
            "all": [
              "Everyone",
              "所有人可见"
            ],
            "friends": [
              "Friends",
              "好友可见"
            ],
            "private": [
              "Only me",
              "仅自己可见"
            ]
          }
        },
        {
          "key": "cover",
          "label": [
            "Cover",
            "封面"
          ],
          "kind": "image",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "accept": "image/*"
        },
        {
          "key": "declaration",
          "label": [
            "Author's note",
            "作者声明"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "location",
          "label": [
            "Location",
            "添加地点"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "video/*",
        "required": true,
        "multiple": false,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "upstream_ref": "ondit-native",
    "publication_hosts": [
      "kuaishou.com",
      "v.kuaishou.com"
    ],
    "unattended": {
      "account": "a[href*='/profile'],.user-name",
      "submit": "button",
      "submit_text": [
        "发布",
        "Publish"
      ],
      "result": "a[href*='kuaishou.com/short-video/']"
    }
  },
  {
    "id": "csdn",
    "name": "CSDN",
    "entry_url": "https://editor.csdn.net/md/",
    "hosts": [
      "editor.csdn.net"
    ],
    "methods": [
      "browser"
    ],
    "dynamic_host": false,
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input.article-bar__title",
            "input[placeholder^=\"请输入文章标题\"]"
          ],
          "empty_values": [
            "【无标题】"
          ]
        },
        {
          "key": "body",
          "label": [
            "Body",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "pre.editor__inner[contenteditable=\"true\"]"
          ],
          "format": "markdown",
          "empty_values": [
            "/^@\\[TOC\\]\\(这里写自定义目录标题\\)$/"
          ]
        },
        {
          "key": "tags",
          "label": [
            "Article tags",
            "文章标签"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "category",
          "label": [
            "Column",
            "分类专栏"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "source",
          "label": [
            "Article type",
            "文章类型"
          ],
          "kind": "select",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "original",
            "reprint",
            "translation"
          ],
          "option_labels": {
            "original": [
              "Original",
              "原创"
            ],
            "reprint": [
              "Reprint",
              "转载"
            ],
            "translation": [
              "Translation",
              "翻译"
            ]
          }
        },
        {
          "key": "cover",
          "label": [
            "Cover",
            "封面"
          ],
          "kind": "image",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "accept": "image/*"
        },
        {
          "key": "summary",
          "label": [
            "Summary",
            "文章摘要"
          ],
          "kind": "textarea",
          "required": false,
          "max_length": 256,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "visibility",
          "label": [
            "Who can see it",
            "可见范围"
          ],
          "kind": "select",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "all",
            "private",
            "followers",
            "vip"
          ],
          "option_labels": {
            "all": [
              "Everyone",
              "全部可见"
            ],
            "private": [
              "Only me",
              "仅我可见"
            ],
            "followers": [
              "Followers",
              "粉丝可见"
            ],
            "vip": [
              "VIP",
              "VIP可见"
            ]
          }
        }
      ],
      "media": {
        "accept": "image/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "verified",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "Ondit fills the title and Markdown body, selects the supplied tags, source and visibility, then publishes at the scheduled time in a signed-in browser.",
        "Ondit 会填入标题和 Markdown 正文，选择已提供的标签、来源和可见范围，并在已登录浏览器中按计划自动发布。"
      ]
    },
    "unattended": {
      "account": "img.img-user-avatar",
      "account_attribute": "src",
      "open_submit": "button.btn.btn-publish",
      "submit": ".modal__publish-article button.button.btn-b-red.ml16",
      "lands_on_post": true,
      "handled_fields": [
        "tags",
        "source",
        "visibility"
      ]
    },
    "upstream_ref": "ondit-native",
    "publication_hosts": [
      "blog.csdn.net"
    ]
  },
  {
    "id": "juejin",
    "name": "稀土掘金",
    "entry_url": "https://juejin.cn/editor/drafts/new",
    "hosts": [
      "juejin.cn"
    ],
    "methods": [
      "browser"
    ],
    "dynamic_host": false,
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input.title-input",
            "input[placeholder=\"输入文章标题...\"]"
          ]
        },
        {
          "key": "body",
          "label": [
            "Body",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            ".CodeMirror"
          ],
          "editor": "codemirror",
          "format": "markdown"
        },
        {
          "key": "category",
          "label": [
            "Category",
            "分类"
          ],
          "kind": "select",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "backend",
            "frontend",
            "android",
            "ios",
            "ai",
            "tooling",
            "career",
            "reading"
          ],
          "option_labels": {
            "backend": [
              "Backend",
              "后端"
            ],
            "frontend": [
              "Frontend",
              "前端"
            ],
            "android": [
              "Android",
              "Android"
            ],
            "ios": [
              "iOS",
              "iOS"
            ],
            "ai": [
              "AI",
              "人工智能"
            ],
            "tooling": [
              "Developer tools",
              "开发工具"
            ],
            "career": [
              "Career",
              "代码人生"
            ],
            "reading": [
              "Reading",
              "阅读"
            ]
          }
        },
        {
          "key": "tags",
          "label": [
            "Tags",
            "标签（在平台选择）"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "summary",
          "label": [
            "Summary",
            "编辑摘要"
          ],
          "kind": "textarea",
          "required": false,
          "max_length": 100,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "cover",
          "label": [
            "Cover",
            "封面"
          ],
          "kind": "image",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "accept": "image/*"
        },
        {
          "key": "column",
          "label": [
            "Columns",
            "收录至专栏"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "topic",
          "label": [
            "Topic",
            "创作话题"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "unattended": {
      "account": ".CodeMirror",
      "account_storage": "SLARDARpassport_account_api",
      "open_submit": "button.xitu-btn:not(.btn-drafts)",
      "submit": "button.ui-btn.btn.primary.medium.default",
      "lands_on_post": true,
      "handled_fields": [
        "category",
        "tags"
      ]
    },
    "upstream_ref": "ondit-native"
  },
  {
    "id": "segmentfault",
    "name": "SegmentFault",
    "entry_url": "https://segmentfault.com/write",
    "hosts": [
      "segmentfault.com"
    ],
    "methods": [
      "browser"
    ],
    "dynamic_host": false,
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input[name=\"title\"]",
            "input[placeholder=\"请输入标题\"]"
          ]
        },
        {
          "key": "body",
          "label": [
            "Body",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            ".CodeMirror"
          ],
          "editor": "codemirror",
          "format": "markdown"
        },
        {
          "key": "tags",
          "label": [
            "Tags",
            "标签（在平台选择）"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "blog",
          "label": [
            "Blog",
            "所属专栏"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "verified",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "The browser assistant fills the title and Markdown editor, selects each supplied platform tag, and submits only after the platform enables its own control.",
        "浏览器助手会填写标题和 Markdown 编辑器，并选择已提供的平台标签；仅在平台自身启用提交按钮后才会提交。"
      ]
    },
    "unattended": {
      "account": "a.nav-link.p-0[href^='/u/']",
      "submit": "div.mb-5.d-none.d-xl-block > button.btn.btn-primary, div.mb-5.mt-3.d-block.d-xl-none > button.btn.btn-primary",
      "result": "a[href^='/a/']",
      "lands_on_post": true,
      "handled_fields": [
        "tags"
      ]
    },
    "publication_hosts": [
      "segmentfault.com"
    ],
    "upstream_ref": "ondit-native"
  },
  {
    "id": "jianshu",
    "name": "简书",
    "entry_url": "https://www.jianshu.com/writer",
    "hosts": [
      "www.jianshu.com"
    ],
    "methods": [
      "browser"
    ],
    "dynamic_host": false,
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input[type=\"text\"]:not([placeholder])"
          ],
          "empty_values": [
            "/^\\d{4}-\\d{2}-\\d{2}$/"
          ]
        },
        {
          "key": "body",
          "label": [
            "Body",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "div.kalamu-area[contenteditable=\"true\"]"
          ],
          "format": "markdown"
        },
        {
          "key": "notebook",
          "label": [
            "Notebook",
            "文集（在平台选择）"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "upstream_ref": "ondit-native",
    "publication_hosts": [
      "jianshu.com"
    ],
    "unattended": {
      "account": "a[href^='/u/']",
      "account_location": "#/notebooks/([^/]+)",
      "submit": "a[data-action='publicize']",
      "result": "a[href^='/p/']",
      "lands_on_post": true
    }
  },
  {
    "id": "quora",
    "name": "Quora",
    "entry_url": "https://www.quora.com/",
    "hosts": [
      "www.quora.com"
    ],
    "methods": [
      "browser"
    ],
    "dynamic_host": false,
    "preview": {
      "layout": "discussion",
      "fields": [
        {
          "key": "destination",
          "label": [
            "Question URL",
            "要回答的问题网址"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Answer",
            "回答正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "[contenteditable=\"true\"][data-kind=\"doc\"]"
          ],
          "format": "rich_text"
        },
        {
          "key": "credential",
          "label": [
            "Answer credential",
            "回答身份／资历"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "upstream_ref": "ondit-native",
    "unattended": {
      "account": "a[href*='/profile/']",
      "submit": "button",
      "submit_text": [
        "Post",
        "发布"
      ],
      "result": "a[href*='/profile/'][href*='/answer/'],a[href*='/answer/']",
      "handled_fields": [
        "destination"
      ]
    }
  },
  {
    "id": "substack",
    "name": "Substack",
    "entry_url": "https://substack.com/publish",
    "hosts": [
      "substack.com"
    ],
    "methods": [
      "browser"
    ],
    "dynamic_host": false,
    "preview": {
      "layout": "newsletter",
      "fields": [
        {
          "key": "destination",
          "label": [
            "Publication editor URL (*.substack.com/publish/…)",
            "刊物编辑页网址（*.substack.com/publish/…）"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea[placeholder=\"Title\"]",
            "input[placeholder=\"Title\"]"
          ]
        },
        {
          "key": "body",
          "label": [
            "Body",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            ".tiptap[contenteditable=\"true\"]",
            ".ProseMirror[contenteditable=\"true\"]"
          ],
          "format": "rich_text"
        },
        {
          "key": "subtitle",
          "label": [
            "Subtitle",
            "副标题"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea[placeholder=\"Subtitle\"]"
          ]
        },
        {
          "key": "audience",
          "label": [
            "Audience",
            "免费／付费受众"
          ],
          "kind": "select",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "everyone",
            "paid",
            "free"
          ],
          "option_labels": {
            "everyone": [
              "Everyone",
              "所有读者"
            ],
            "paid": [
              "Paid subscribers",
              "付费订阅者"
            ],
            "free": [
              "Free subscribers",
              "免费订阅者"
            ]
          }
        },
        {
          "key": "delivery",
          "label": [
            "Email and app delivery",
            "是否发送邮件和 App 通知"
          ],
          "kind": "select",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "web_only",
            "email_and_app"
          ],
          "option_labels": {
            "web_only": [
              "Web only",
              "仅发布到网页"
            ],
            "email_and_app": [
              "Email and app inbox",
              "同时发送邮件和 App 通知"
            ]
          }
        }
      ],
      "media": {
        "accept": "image/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in account, the browser assistant fills the approved content, resolves visible platform settings, publishes at the scheduled time, and returns the public URL to Ondit. Login, CAPTCHA and platform verification pause the task until the account is ready.",
        "账号已登录时，浏览器助手会填入已确认内容、处理页面上的发布设置、到点自动发布，并把公开链接回填到 Ondit。登录、验证码或平台强制验证会暂停任务，账号恢复后继续。"
      ]
    },
    "upstream_ref": "ondit-native",
    "unattended": {
      "account": "button[aria-label*='account' i],a[href*='/publish/settings']",
      "open_submit": "button",
      "open_submit_text": [
        "Continue",
        "Publish",
        "继续"
      ],
      "submit": "button",
      "submit_text": [
        "Publish now",
        "Publish",
        "Send to everyone",
        "立即发布"
      ],
      "result": "a[href*='/p/']",
      "handled_fields": [
        "destination"
      ]
    }
  },
  {
    "id": "51cto",
    "name": "51CTO",
    "methods": [
      "browser"
    ],
    "entry_url": "https://blog.51cto.com/blogger/publish",
    "dynamic_host": false,
    "hosts": [
      "blog.51cto.com",
      "51cto.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input[name='title']",
            "textarea[name='title']",
            "input[placeholder*='title' i]",
            "textarea[placeholder*='title' i]",
            "input[placeholder*='标题']",
            "textarea[placeholder*='标题']",
            "input[placeholder*='標題']"
          ]
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea[name='body']",
            "textarea[name='content']",
            "[contenteditable='true'][role='textbox']",
            ".ProseMirror[contenteditable='true']",
            ".CodeMirror textarea",
            "textarea[placeholder*='content' i]",
            "textarea[placeholder*='正文']",
            "textarea[placeholder*='内容']"
          ],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in publishing account, Ondit fills the editor, uses the platform's visible publish controls, and verifies the resulting public URL. Login, CAPTCHA, moderation, payment and identity checks pause the task instead of being bypassed.",
        "发布账号已登录时，Ondit 会填写编辑器、操作平台可见的发布控件并验证公开链接。登录、验证码、内容审核、付款或实名验证会暂停任务，不会绕过。"
      ]
    },
    "unattended": {
      "editor_paths": [
        "^/blogger/(?:publish|draft)"
      ],
      "account": "a[href*='/blogger/'],a[href*='/u_']",
      "submit": "button[type='submit'],button,[role='button']",
      "submit_text": [
        "发布文章",
        "发布"
      ],
      "confirm_submit": "[role='dialog'] button,.modal button,.drawer button",
      "confirm_submit_text": [
        "确认发布",
        "发布"
      ],
      "result": "a[href*='blog.51cto.com/'][href*='/posts/'],a[href*='blog.51cto.com/'][href*='/article/']",
      "lands_on_post": true
    },
    "upstream_ref": "ondit-catalog:2026-09-28"
  },
  {
    "id": "52pojie",
    "name": "吾爱破解论坛",
    "methods": [
      "browser"
    ],
    "entry_url": "https://www.52pojie.cn/forum.php?mod=post&action=newthread&fid=2",
    "dynamic_host": false,
    "hosts": [
      "www.52pojie.cn",
      "52pojie.cn"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input[name='title']",
            "textarea[name='title']",
            "input[placeholder*='title' i]",
            "textarea[placeholder*='title' i]",
            "input[placeholder*='标题']",
            "textarea[placeholder*='标题']",
            "input[placeholder*='標題']"
          ]
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea[name='body']",
            "textarea[name='content']",
            "[contenteditable='true'][role='textbox']",
            ".ProseMirror[contenteditable='true']",
            ".CodeMirror textarea",
            "textarea[placeholder*='content' i]",
            "textarea[placeholder*='正文']",
            "textarea[placeholder*='内容']"
          ],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in publishing account, Ondit fills the editor, uses the platform's visible publish controls, and verifies the resulting public URL. Login, CAPTCHA, moderation, payment and identity checks pause the task instead of being bypassed.",
        "发布账号已登录时，Ondit 会填写编辑器、操作平台可见的发布控件并验证公开链接。登录、验证码、内容审核、付款或实名验证会暂停任务，不会绕过。"
      ]
    },
    "unattended": {
      "editor_paths": [
        "^/forum\\.php\\?.*(?:mod=post|action=newthread)"
      ],
      "account": "a[href*='home.php?mod=space&uid=']",
      "submit": "button[type='submit'],button,[role='button']",
      "submit_text": [
        "发表帖子",
        "发布主题"
      ],
      "result": "a[href*='thread-'],a[href*='viewthread']",
      "lands_on_post": true
    },
    "upstream_ref": "ondit-catalog:2026-09-28"
  },
  {
    "id": "alignable",
    "name": "Alignable",
    "methods": [
      "browser"
    ],
    "entry_url": "https://www.alignable.com/biz/posts/new",
    "dynamic_host": false,
    "hosts": [
      "www.alignable.com",
      "alignable.com"
    ],
    "preview": {
      "layout": "social",
      "fields": [
        {
          "key": "body",
          "label": [
            "Post",
            "内容"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea[name='body']",
            "textarea[name='content']",
            "[contenteditable='true'][role='textbox']",
            ".ProseMirror[contenteditable='true']",
            ".CodeMirror textarea",
            "textarea[placeholder*='content' i]",
            "textarea[placeholder*='正文']",
            "textarea[placeholder*='内容']"
          ],
          "format": "plain"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in publishing account, Ondit fills the editor, uses the platform's visible publish controls, and verifies the resulting public URL. Login, CAPTCHA, moderation, payment and identity checks pause the task instead of being bypassed.",
        "发布账号已登录时，Ondit 会填写编辑器、操作平台可见的发布控件并验证公开链接。登录、验证码、内容审核、付款或实名验证会暂停任务，不会绕过。"
      ]
    },
    "unattended": {
      "editor_paths": [
        "/posts/(?:new|compose)"
      ],
      "account": "a[href*='/biz/'],a[href*='/profile/']",
      "submit": "button[type='submit'],button,[role='button']",
      "submit_text": [
        "Post",
        "Publish"
      ],
      "result": "a[href*='/posts/']",
      "lands_on_post": true
    },
    "upstream_ref": "ondit-catalog:2026-09-28"
  },
  {
    "id": "cloud-tencent",
    "name": "腾讯云开发者社区",
    "methods": [
      "browser"
    ],
    "entry_url": "https://cloud.tencent.com/developer/article/write",
    "dynamic_host": false,
    "hosts": [
      "cloud.tencent.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input[name='title']",
            "textarea[name='title']",
            "input[placeholder*='title' i]",
            "textarea[placeholder*='title' i]",
            "input[placeholder*='标题']",
            "textarea[placeholder*='标题']",
            "input[placeholder*='標題']"
          ]
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea[name='body']",
            "textarea[name='content']",
            "[contenteditable='true'][role='textbox']",
            ".ProseMirror[contenteditable='true']",
            ".CodeMirror textarea",
            "textarea[placeholder*='content' i]",
            "textarea[placeholder*='正文']",
            "textarea[placeholder*='内容']"
          ],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in publishing account, Ondit fills the editor, uses the platform's visible publish controls, and verifies the resulting public URL. Login, CAPTCHA, moderation, payment and identity checks pause the task instead of being bypassed.",
        "发布账号已登录时，Ondit 会填写编辑器、操作平台可见的发布控件并验证公开链接。登录、验证码、内容审核、付款或实名验证会暂停任务，不会绕过。"
      ]
    },
    "unattended": {
      "editor_paths": [
        "^/developer/article/(?:write|edit)"
      ],
      "account": "a[href*='/developer/user/'],a[href*='/developer/column/']",
      "submit": "button[type='submit'],button,[role='button']",
      "submit_text": [
        "发布",
        "确认发布"
      ],
      "confirm_submit": "[role='dialog'] button,.modal button,.drawer button",
      "confirm_submit_text": [
        "确认并发布",
        "确认发布"
      ],
      "result": "a[href*='/developer/article/']",
      "lands_on_post": true
    },
    "upstream_ref": "ondit-catalog:2026-09-28"
  },
  {
    "id": "cnblogs",
    "name": "博客园",
    "methods": [
      "browser"
    ],
    "entry_url": "https://i.cnblogs.com/posts/edit",
    "dynamic_host": false,
    "hosts": [
      "i.cnblogs.com",
      "cnblogs.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input[name='title']",
            "textarea[name='title']",
            "input[placeholder*='title' i]",
            "textarea[placeholder*='title' i]",
            "input[placeholder*='标题']",
            "textarea[placeholder*='标题']",
            "input[placeholder*='標題']"
          ]
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea[name='body']",
            "textarea[name='content']",
            "[contenteditable='true'][role='textbox']",
            ".ProseMirror[contenteditable='true']",
            ".CodeMirror textarea",
            "textarea[placeholder*='content' i]",
            "textarea[placeholder*='正文']",
            "textarea[placeholder*='内容']"
          ],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in publishing account, Ondit fills the editor, uses the platform's visible publish controls, and verifies the resulting public URL. Login, CAPTCHA, moderation, payment and identity checks pause the task instead of being bypassed.",
        "发布账号已登录时，Ondit 会填写编辑器、操作平台可见的发布控件并验证公开链接。登录、验证码、内容审核、付款或实名验证会暂停任务，不会绕过。"
      ]
    },
    "unattended": {
      "editor_paths": [
        "^/posts/(?:edit|new)"
      ],
      "account": "a[href*='www.cnblogs.com/'][target='_blank']",
      "submit": "button[type='submit'],button,[role='button']",
      "submit_text": [
        "发布",
        "Publish"
      ],
      "result": "a[href*='cnblogs.com/'][href*='/p/']",
      "lands_on_post": true
    },
    "upstream_ref": "ondit-catalog:2026-09-28"
  },
  {
    "id": "dcard",
    "name": "Dcard",
    "methods": [
      "browser"
    ],
    "entry_url": "https://www.dcard.tw/create-post",
    "dynamic_host": false,
    "hosts": [
      "www.dcard.tw",
      "dcard.tw"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input[name='title']",
            "textarea[name='title']",
            "input[placeholder*='title' i]",
            "textarea[placeholder*='title' i]",
            "input[placeholder*='标题']",
            "textarea[placeholder*='标题']",
            "input[placeholder*='標題']"
          ]
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea[name='body']",
            "textarea[name='content']",
            "[contenteditable='true'][role='textbox']",
            ".ProseMirror[contenteditable='true']",
            ".CodeMirror textarea",
            "textarea[placeholder*='content' i]",
            "textarea[placeholder*='正文']",
            "textarea[placeholder*='内容']"
          ],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in publishing account, Ondit fills the editor, uses the platform's visible publish controls, and verifies the resulting public URL. Login, CAPTCHA, moderation, payment and identity checks pause the task instead of being bypassed.",
        "发布账号已登录时，Ondit 会填写编辑器、操作平台可见的发布控件并验证公开链接。登录、验证码、内容审核、付款或实名验证会暂停任务，不会绕过。"
      ]
    },
    "unattended": {
      "editor_paths": [
        "^/(?:create-post|f/[^/]+/p/create)"
      ],
      "account": "a[href*='/@'],a[href*='/profile']",
      "submit": "button[type='submit'],button,[role='button']",
      "submit_text": [
        "發佈",
        "发布",
        "Publish"
      ],
      "confirm_submit": "[role='dialog'] button,.modal button,.drawer button",
      "confirm_submit_text": [
        "確認發佈",
        "确认发布"
      ],
      "result": "a[href*='/f/'][href*='/p/']",
      "lands_on_post": true
    },
    "upstream_ref": "ondit-catalog:2026-09-28"
  },
  {
    "id": "developer-aliyun",
    "name": "阿里云开发者社区",
    "methods": [
      "browser"
    ],
    "entry_url": "https://developer.aliyun.com/article/new",
    "dynamic_host": false,
    "hosts": [
      "developer.aliyun.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input[name='title']",
            "textarea[name='title']",
            "input[placeholder*='title' i]",
            "textarea[placeholder*='title' i]",
            "input[placeholder*='标题']",
            "textarea[placeholder*='标题']",
            "input[placeholder*='標題']"
          ]
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea[name='body']",
            "textarea[name='content']",
            "[contenteditable='true'][role='textbox']",
            ".ProseMirror[contenteditable='true']",
            ".CodeMirror textarea",
            "textarea[placeholder*='content' i]",
            "textarea[placeholder*='正文']",
            "textarea[placeholder*='内容']"
          ],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in publishing account, Ondit fills the editor, uses the platform's visible publish controls, and verifies the resulting public URL. Login, CAPTCHA, moderation, payment and identity checks pause the task instead of being bypassed.",
        "发布账号已登录时，Ondit 会填写编辑器、操作平台可见的发布控件并验证公开链接。登录、验证码、内容审核、付款或实名验证会暂停任务，不会绕过。"
      ]
    },
    "unattended": {
      "editor_paths": [
        "^/article/(?:new|edit)"
      ],
      "account": "a[href*='/profile/'],a[href*='/user/']",
      "submit": "button[type='submit'],button,[role='button']",
      "submit_text": [
        "发布文章",
        "发布"
      ],
      "confirm_submit": "[role='dialog'] button,.modal button,.drawer button",
      "confirm_submit_text": [
        "确认发布",
        "发布"
      ],
      "result": "a[href*='/article/']",
      "lands_on_post": true
    },
    "upstream_ref": "ondit-catalog:2026-09-28"
  },
  {
    "id": "douban",
    "name": "豆瓣",
    "methods": [
      "browser"
    ],
    "entry_url": "https://www.douban.com/note/create",
    "dynamic_host": false,
    "hosts": [
      "www.douban.com",
      "douban.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input[name='title']",
            "textarea[name='title']",
            "input[placeholder*='title' i]",
            "textarea[placeholder*='title' i]",
            "input[placeholder*='标题']",
            "textarea[placeholder*='标题']",
            "input[placeholder*='標題']"
          ]
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea[name='body']",
            "textarea[name='content']",
            "[contenteditable='true'][role='textbox']",
            ".ProseMirror[contenteditable='true']",
            ".CodeMirror textarea",
            "textarea[placeholder*='content' i]",
            "textarea[placeholder*='正文']",
            "textarea[placeholder*='内容']"
          ],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in publishing account, Ondit fills the editor, uses the platform's visible publish controls, and verifies the resulting public URL. Login, CAPTCHA, moderation, payment and identity checks pause the task instead of being bypassed.",
        "发布账号已登录时，Ondit 会填写编辑器、操作平台可见的发布控件并验证公开链接。登录、验证码、内容审核、付款或实名验证会暂停任务，不会绕过。"
      ]
    },
    "unattended": {
      "editor_paths": [
        "^/note/(?:create|edit)"
      ],
      "account": "a[href*='douban.com/people/']",
      "submit": "button[type='submit'],button,[role='button']",
      "submit_text": [
        "发表",
        "发布"
      ],
      "result": "a[href*='douban.com/note/']",
      "lands_on_post": true
    },
    "upstream_ref": "ondit-catalog:2026-09-28"
  },
  {
    "id": "eleduck",
    "name": "电鸭社区",
    "methods": [
      "browser"
    ],
    "entry_url": "https://eleduck.com/posts/new",
    "dynamic_host": false,
    "hosts": [
      "eleduck.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input[name='title']",
            "textarea[name='title']",
            "input[placeholder*='title' i]",
            "textarea[placeholder*='title' i]",
            "input[placeholder*='标题']",
            "textarea[placeholder*='标题']",
            "input[placeholder*='標題']"
          ]
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea[name='body']",
            "textarea[name='content']",
            "[contenteditable='true'][role='textbox']",
            ".ProseMirror[contenteditable='true']",
            ".CodeMirror textarea",
            "textarea[placeholder*='content' i]",
            "textarea[placeholder*='正文']",
            "textarea[placeholder*='内容']"
          ],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in publishing account, Ondit fills the editor, uses the platform's visible publish controls, and verifies the resulting public URL. Login, CAPTCHA, moderation, payment and identity checks pause the task instead of being bypassed.",
        "发布账号已登录时，Ondit 会填写编辑器、操作平台可见的发布控件并验证公开链接。登录、验证码、内容审核、付款或实名验证会暂停任务，不会绕过。"
      ]
    },
    "unattended": {
      "editor_paths": [
        "^/posts/(?:new|[^/]+/edit)"
      ],
      "account": "a[href*='/users/'],a[href*='/user/']",
      "submit": "button[type='submit'],button,[role='button']",
      "submit_text": [
        "发布",
        "Publish"
      ],
      "result": "a[href*='/posts/']",
      "lands_on_post": true
    },
    "upstream_ref": "ondit-catalog:2026-09-28"
  },
  {
    "id": "feng",
    "name": "威锋网",
    "methods": [
      "browser"
    ],
    "entry_url": "https://www.feng.com/forum/thread/new",
    "dynamic_host": false,
    "hosts": [
      "www.feng.com",
      "feng.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input[name='title']",
            "textarea[name='title']",
            "input[placeholder*='title' i]",
            "textarea[placeholder*='title' i]",
            "input[placeholder*='标题']",
            "textarea[placeholder*='标题']",
            "input[placeholder*='標題']"
          ]
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea[name='body']",
            "textarea[name='content']",
            "[contenteditable='true'][role='textbox']",
            ".ProseMirror[contenteditable='true']",
            ".CodeMirror textarea",
            "textarea[placeholder*='content' i]",
            "textarea[placeholder*='正文']",
            "textarea[placeholder*='内容']"
          ],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in publishing account, Ondit fills the editor, uses the platform's visible publish controls, and verifies the resulting public URL. Login, CAPTCHA, moderation, payment and identity checks pause the task instead of being bypassed.",
        "发布账号已登录时，Ondit 会填写编辑器、操作平台可见的发布控件并验证公开链接。登录、验证码、内容审核、付款或实名验证会暂停任务，不会绕过。"
      ]
    },
    "unattended": {
      "editor_paths": [
        "/forum/.+(?:new|post|edit)"
      ],
      "account": "a[href*='/user/'],a[href*='/profile/']",
      "submit": "button[type='submit'],button,[role='button']",
      "submit_text": [
        "发表主题",
        "发布"
      ],
      "result": "a[href*='/post/'],a[href*='/thread/']",
      "lands_on_post": true
    },
    "upstream_ref": "ondit-catalog:2026-09-28"
  },
  {
    "id": "forums-ilounge-com",
    "name": "forums.ilounge.com",
    "methods": [
      "browser"
    ],
    "entry_url": "https://forums.ilounge.com/forums/-/post-thread",
    "dynamic_host": false,
    "hosts": [
      "forums.ilounge.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input[name='title']",
            "textarea[name='title']",
            "input[placeholder*='title' i]",
            "textarea[placeholder*='title' i]",
            "input[placeholder*='标题']",
            "textarea[placeholder*='标题']",
            "input[placeholder*='標題']"
          ]
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea[name='body']",
            "textarea[name='content']",
            "[contenteditable='true'][role='textbox']",
            ".ProseMirror[contenteditable='true']",
            ".CodeMirror textarea",
            "textarea[placeholder*='content' i]",
            "textarea[placeholder*='正文']",
            "textarea[placeholder*='内容']"
          ],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in publishing account, Ondit fills the editor, uses the platform's visible publish controls, and verifies the resulting public URL. Login, CAPTCHA, moderation, payment and identity checks pause the task instead of being bypassed.",
        "发布账号已登录时，Ondit 会填写编辑器、操作平台可见的发布控件并验证公开链接。登录、验证码、内容审核、付款或实名验证会暂停任务，不会绕过。"
      ]
    },
    "unattended": {
      "editor_paths": [
        "/(?:post-thread|threads/.+/edit)"
      ],
      "account": "a[href*='/members/']",
      "submit": "button[type='submit'],button,[role='button']",
      "submit_text": [
        "Post thread",
        "Save"
      ],
      "result": "a[href*='/threads/']",
      "lands_on_post": true
    },
    "upstream_ref": "ondit-catalog:2026-09-28"
  },
  {
    "id": "hackernoon",
    "name": "HackerNoon",
    "methods": [
      "browser"
    ],
    "entry_url": "https://app.hackernoon.com/new",
    "dynamic_host": false,
    "hosts": [
      "hackernoon.com",
      "app.hackernoon.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input[name='title']",
            "textarea[name='title']",
            "input[placeholder*='title' i]",
            "textarea[placeholder*='title' i]",
            "input[placeholder*='标题']",
            "textarea[placeholder*='标题']",
            "input[placeholder*='標題']"
          ]
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea[name='body']",
            "textarea[name='content']",
            "[contenteditable='true'][role='textbox']",
            ".ProseMirror[contenteditable='true']",
            ".CodeMirror textarea",
            "textarea[placeholder*='content' i]",
            "textarea[placeholder*='正文']",
            "textarea[placeholder*='内容']"
          ],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in publishing account, Ondit fills the editor, uses the platform's visible publish controls, and verifies the resulting public URL. Login, CAPTCHA, moderation, payment and identity checks pause the task instead of being bypassed.",
        "发布账号已登录时，Ondit 会填写编辑器、操作平台可见的发布控件并验证公开链接。登录、验证码、内容审核、付款或实名验证会暂停任务，不会绕过。"
      ]
    },
    "unattended": {
      "editor_paths": [
        "^/(?:new|drafts/.+)"
      ],
      "account": "a[href*='/u/'],a[href*='/profile/']",
      "submit": "button[type='submit'],button,[role='button']",
      "submit_text": [
        "Publish",
        "Submit story"
      ],
      "confirm_submit": "[role='dialog'] button,.modal button,.drawer button",
      "confirm_submit_text": [
        "Publish story",
        "Publish"
      ],
      "result": "a[href*='hackernoon.com/']",
      "lands_on_post": true
    },
    "upstream_ref": "ondit-catalog:2026-09-28"
  },
  {
    "id": "indiehackers",
    "name": "Indie Hackers",
    "methods": [
      "browser"
    ],
    "entry_url": "https://www.indiehackers.com/post",
    "dynamic_host": false,
    "hosts": [
      "www.indiehackers.com",
      "indiehackers.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input[name='title']",
            "textarea[name='title']",
            "input[placeholder*='title' i]",
            "textarea[placeholder*='title' i]",
            "input[placeholder*='标题']",
            "textarea[placeholder*='标题']",
            "input[placeholder*='標題']"
          ]
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea[name='body']",
            "textarea[name='content']",
            "[contenteditable='true'][role='textbox']",
            ".ProseMirror[contenteditable='true']",
            ".CodeMirror textarea",
            "textarea[placeholder*='content' i]",
            "textarea[placeholder*='正文']",
            "textarea[placeholder*='内容']"
          ],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in publishing account, Ondit fills the editor, uses the platform's visible publish controls, and verifies the resulting public URL. Login, CAPTCHA, moderation, payment and identity checks pause the task instead of being bypassed.",
        "发布账号已登录时，Ondit 会填写编辑器、操作平台可见的发布控件并验证公开链接。登录、验证码、内容审核、付款或实名验证会暂停任务，不会绕过。"
      ]
    },
    "unattended": {
      "editor_paths": [
        "^/post(?:/new|/[^/]+/edit)?$"
      ],
      "account": "a[href*='/@']",
      "submit": "button[type='submit'],button,[role='button']",
      "submit_text": [
        "Publish",
        "Post"
      ],
      "result": "a[href*='/post/']",
      "lands_on_post": true
    },
    "upstream_ref": "ondit-catalog:2026-09-28"
  },
  {
    "id": "infoq",
    "name": "InfoQ 写作社区",
    "methods": [
      "browser"
    ],
    "entry_url": "https://xie.infoq.cn/article/create",
    "dynamic_host": false,
    "hosts": [
      "infoq.cn",
      "xie.infoq.cn"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input[name='title']",
            "textarea[name='title']",
            "input[placeholder*='title' i]",
            "textarea[placeholder*='title' i]",
            "input[placeholder*='标题']",
            "textarea[placeholder*='标题']",
            "input[placeholder*='標題']"
          ]
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea[name='body']",
            "textarea[name='content']",
            "[contenteditable='true'][role='textbox']",
            ".ProseMirror[contenteditable='true']",
            ".CodeMirror textarea",
            "textarea[placeholder*='content' i]",
            "textarea[placeholder*='正文']",
            "textarea[placeholder*='内容']"
          ],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in publishing account, Ondit fills the editor, uses the platform's visible publish controls, and verifies the resulting public URL. Login, CAPTCHA, moderation, payment and identity checks pause the task instead of being bypassed.",
        "发布账号已登录时，Ondit 会填写编辑器、操作平台可见的发布控件并验证公开链接。登录、验证码、内容审核、付款或实名验证会暂停任务，不会绕过。"
      ]
    },
    "unattended": {
      "editor_paths": [
        "^/article/(?:create|edit)"
      ],
      "account": "a[href*='/profile/'],a[href*='/user/']",
      "submit": "button[type='submit'],button,[role='button']",
      "submit_text": [
        "发布",
        "提交审核"
      ],
      "confirm_submit": "[role='dialog'] button,.modal button,.drawer button",
      "confirm_submit_text": [
        "确认发布",
        "提交审核"
      ],
      "result": "a[href*='xie.infoq.cn/article/'],a[href*='infoq.cn/article/']",
      "lands_on_post": true
    },
    "upstream_ref": "ondit-catalog:2026-09-28"
  },
  {
    "id": "lobsters",
    "name": "Lobsters",
    "methods": [
      "browser"
    ],
    "entry_url": "https://lobste.rs/stories/new",
    "dynamic_host": false,
    "hosts": [
      "lobste.rs"
    ],
    "preview": {
      "layout": "social",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input[name='title']",
            "textarea[name='title']",
            "input[placeholder*='title' i]",
            "textarea[placeholder*='title' i]",
            "input[placeholder*='标题']",
            "textarea[placeholder*='标题']",
            "input[placeholder*='標題']"
          ]
        },
        {
          "key": "body",
          "label": [
            "Post",
            "内容"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea[name='body']",
            "textarea[name='content']",
            "[contenteditable='true'][role='textbox']",
            ".ProseMirror[contenteditable='true']",
            ".CodeMirror textarea",
            "textarea[placeholder*='content' i]",
            "textarea[placeholder*='正文']",
            "textarea[placeholder*='内容']"
          ],
          "format": "plain"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in publishing account, Ondit fills the editor, uses the platform's visible publish controls, and verifies the resulting public URL. Login, CAPTCHA, moderation, payment and identity checks pause the task instead of being bypassed.",
        "发布账号已登录时，Ondit 会填写编辑器、操作平台可见的发布控件并验证公开链接。登录、验证码、内容审核、付款或实名验证会暂停任务，不会绕过。"
      ]
    },
    "unattended": {
      "editor_paths": [
        "^/stories/(?:new|[^/]+/edit)"
      ],
      "account": "a[href*='/u/']",
      "submit": "button[type='submit'],button,[role='button']",
      "submit_text": [
        "Submit",
        "Save"
      ],
      "result": "a[href*='/s/']",
      "lands_on_post": true
    },
    "upstream_ref": "ondit-catalog:2026-09-28"
  },
  {
    "id": "meta-appinn",
    "name": "小众软件 发现频道",
    "methods": [
      "browser"
    ],
    "entry_url": "https://meta.appinn.net/new-topic?category=10",
    "dynamic_host": false,
    "hosts": [
      "meta.appinn.net"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input[name='title']",
            "textarea[name='title']",
            "input[placeholder*='title' i]",
            "textarea[placeholder*='title' i]",
            "input[placeholder*='标题']",
            "textarea[placeholder*='标题']",
            "input[placeholder*='標題']"
          ]
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea[name='body']",
            "textarea[name='content']",
            "[contenteditable='true'][role='textbox']",
            ".ProseMirror[contenteditable='true']",
            ".CodeMirror textarea",
            "textarea[placeholder*='content' i]",
            "textarea[placeholder*='正文']",
            "textarea[placeholder*='内容']"
          ],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in publishing account, Ondit fills the editor, uses the platform's visible publish controls, and verifies the resulting public URL. Login, CAPTCHA, moderation, payment and identity checks pause the task instead of being bypassed.",
        "发布账号已登录时，Ondit 会填写编辑器、操作平台可见的发布控件并验证公开链接。登录、验证码、内容审核、付款或实名验证会暂停任务，不会绕过。"
      ]
    },
    "unattended": {
      "editor_paths": [
        "^/(?:new-topic|t/)"
      ],
      "account": "a[href*='/u/']",
      "submit": "button[type='submit'],button,[role='button']",
      "submit_text": [
        "创建话题",
        "Create Topic"
      ],
      "result": "a[href*='/t/']",
      "lands_on_post": true
    },
    "upstream_ref": "ondit-catalog:2026-09-28"
  },
  {
    "id": "mobile01",
    "name": "Mobile01",
    "methods": [
      "browser"
    ],
    "entry_url": "https://www.mobile01.com/topiccreate.php",
    "dynamic_host": false,
    "hosts": [
      "www.mobile01.com",
      "mobile01.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input[name='title']",
            "textarea[name='title']",
            "input[placeholder*='title' i]",
            "textarea[placeholder*='title' i]",
            "input[placeholder*='标题']",
            "textarea[placeholder*='标题']",
            "input[placeholder*='標題']"
          ]
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea[name='body']",
            "textarea[name='content']",
            "[contenteditable='true'][role='textbox']",
            ".ProseMirror[contenteditable='true']",
            ".CodeMirror textarea",
            "textarea[placeholder*='content' i]",
            "textarea[placeholder*='正文']",
            "textarea[placeholder*='内容']"
          ],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in publishing account, Ondit fills the editor, uses the platform's visible publish controls, and verifies the resulting public URL. Login, CAPTCHA, moderation, payment and identity checks pause the task instead of being bypassed.",
        "发布账号已登录时，Ondit 会填写编辑器、操作平台可见的发布控件并验证公开链接。登录、验证码、内容审核、付款或实名验证会暂停任务，不会绕过。"
      ]
    },
    "unattended": {
      "editor_paths": [
        "^/topiccreate\\.php"
      ],
      "account": "a[href*='/userinfo.php?id=']",
      "submit": "button[type='submit'],button,[role='button']",
      "submit_text": [
        "發表文章",
        "发布文章"
      ],
      "confirm_submit": "[role='dialog'] button,.modal button,.drawer button",
      "confirm_submit_text": [
        "確認發表",
        "确认发布"
      ],
      "result": "a[href*='/topicdetail.php']",
      "lands_on_post": true
    },
    "upstream_ref": "ondit-catalog:2026-09-28"
  },
  {
    "id": "mp-163",
    "name": "网易号",
    "methods": [
      "browser"
    ],
    "entry_url": "https://mp.163.com/subscribe_v4/index.html#/article-publish",
    "dynamic_host": false,
    "hosts": [
      "mp.163.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input[name='title']",
            "textarea[name='title']",
            "input[placeholder*='title' i]",
            "textarea[placeholder*='title' i]",
            "input[placeholder*='标题']",
            "textarea[placeholder*='标题']",
            "input[placeholder*='標題']"
          ]
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea[name='body']",
            "textarea[name='content']",
            "[contenteditable='true'][role='textbox']",
            ".ProseMirror[contenteditable='true']",
            ".CodeMirror textarea",
            "textarea[placeholder*='content' i]",
            "textarea[placeholder*='正文']",
            "textarea[placeholder*='内容']"
          ],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in publishing account, Ondit fills the editor, uses the platform's visible publish controls, and verifies the resulting public URL. Login, CAPTCHA, moderation, payment and identity checks pause the task instead of being bypassed.",
        "发布账号已登录时，Ondit 会填写编辑器、操作平台可见的发布控件并验证公开链接。登录、验证码、内容审核、付款或实名验证会暂停任务，不会绕过。"
      ]
    },
    "unattended": {
      "editor_paths": [
        "#/article-(?:publish|edit)"
      ],
      "account": "a[href*='account'],.user-name",
      "submit": "button[type='submit'],button,[role='button']",
      "submit_text": [
        "发布",
        "发表"
      ],
      "confirm_submit": "[role='dialog'] button,.modal button,.drawer button",
      "confirm_submit_text": [
        "确认发布",
        "发布"
      ],
      "result": "a[href*='163.com/dy/article/']",
      "lands_on_post": true
    },
    "upstream_ref": "ondit-catalog:2026-09-28"
  },
  {
    "id": "mp-sohu",
    "name": "搜狐号",
    "methods": [
      "browser"
    ],
    "entry_url": "https://mp.sohu.com/mpfe/v4/article/create",
    "dynamic_host": false,
    "hosts": [
      "mp.sohu.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input[name='title']",
            "textarea[name='title']",
            "input[placeholder*='title' i]",
            "textarea[placeholder*='title' i]",
            "input[placeholder*='标题']",
            "textarea[placeholder*='标题']",
            "input[placeholder*='標題']"
          ]
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea[name='body']",
            "textarea[name='content']",
            "[contenteditable='true'][role='textbox']",
            ".ProseMirror[contenteditable='true']",
            ".CodeMirror textarea",
            "textarea[placeholder*='content' i]",
            "textarea[placeholder*='正文']",
            "textarea[placeholder*='内容']"
          ],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in publishing account, Ondit fills the editor, uses the platform's visible publish controls, and verifies the resulting public URL. Login, CAPTCHA, moderation, payment and identity checks pause the task instead of being bypassed.",
        "发布账号已登录时，Ondit 会填写编辑器、操作平台可见的发布控件并验证公开链接。登录、验证码、内容审核、付款或实名验证会暂停任务，不会绕过。"
      ]
    },
    "unattended": {
      "editor_paths": [
        "/article/(?:create|edit)"
      ],
      "account": "a[href*='/profile'],.user-name",
      "submit": "button[type='submit'],button,[role='button']",
      "submit_text": [
        "发布",
        "Publish"
      ],
      "confirm_submit": "[role='dialog'] button,.modal button,.drawer button",
      "confirm_submit_text": [
        "确认发布",
        "发布"
      ],
      "result": "a[href*='sohu.com/a/']",
      "lands_on_post": true
    },
    "upstream_ref": "ondit-catalog:2026-09-28"
  },
  {
    "id": "om-qq",
    "name": "企鹅号（腾讯内容开放平台）",
    "methods": [
      "browser"
    ],
    "entry_url": "https://om.qq.com/userAuth/index",
    "dynamic_host": false,
    "hosts": [
      "om.qq.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input[name='title']",
            "textarea[name='title']",
            "input[placeholder*='title' i]",
            "textarea[placeholder*='title' i]",
            "input[placeholder*='标题']",
            "textarea[placeholder*='标题']",
            "input[placeholder*='標題']"
          ]
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea[name='body']",
            "textarea[name='content']",
            "[contenteditable='true'][role='textbox']",
            ".ProseMirror[contenteditable='true']",
            ".CodeMirror textarea",
            "textarea[placeholder*='content' i]",
            "textarea[placeholder*='正文']",
            "textarea[placeholder*='内容']"
          ],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in publishing account, Ondit fills the editor, uses the platform's visible publish controls, and verifies the resulting public URL. Login, CAPTCHA, moderation, payment and identity checks pause the task instead of being bypassed.",
        "发布账号已登录时，Ondit 会填写编辑器、操作平台可见的发布控件并验证公开链接。登录、验证码、内容审核、付款或实名验证会暂停任务，不会绕过。"
      ]
    },
    "unattended": {
      "editor_paths": [
        "/(?:article|publish|editor)"
      ],
      "account": "a[href*='account'],.user-name",
      "submit": "button[type='submit'],button,[role='button']",
      "submit_text": [
        "发布",
        "发表"
      ],
      "confirm_submit": "[role='dialog'] button,.modal button,.drawer button",
      "confirm_submit_text": [
        "确认发布",
        "发布"
      ],
      "result": "a[href*='new.qq.com/rain/a/'],a[href*='page.om.qq.com/page/']",
      "lands_on_post": true
    },
    "upstream_ref": "ondit-catalog:2026-09-28"
  },
  {
    "id": "pixnet",
    "name": "痞客邦 PIXNET",
    "methods": [
      "browser"
    ],
    "entry_url": "https://panel.pixnet.cc/blog/articles/new",
    "dynamic_host": false,
    "hosts": [
      "pixnet.net",
      "panel.pixnet.cc"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input[name='title']",
            "textarea[name='title']",
            "input[placeholder*='title' i]",
            "textarea[placeholder*='title' i]",
            "input[placeholder*='标题']",
            "textarea[placeholder*='标题']",
            "input[placeholder*='標題']"
          ]
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea[name='body']",
            "textarea[name='content']",
            "[contenteditable='true'][role='textbox']",
            ".ProseMirror[contenteditable='true']",
            ".CodeMirror textarea",
            "textarea[placeholder*='content' i]",
            "textarea[placeholder*='正文']",
            "textarea[placeholder*='内容']"
          ],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in publishing account, Ondit fills the editor, uses the platform's visible publish controls, and verifies the resulting public URL. Login, CAPTCHA, moderation, payment and identity checks pause the task instead of being bypassed.",
        "发布账号已登录时，Ondit 会填写编辑器、操作平台可见的发布控件并验证公开链接。登录、验证码、内容审核、付款或实名验证会暂停任务，不会绕过。"
      ]
    },
    "unattended": {
      "editor_paths": [
        "/blog/articles/(?:new|[^/]+/edit)"
      ],
      "account": "a[href*='/account'],a[href*='pixnet.net/blog']",
      "submit": "button[type='submit'],button,[role='button']",
      "submit_text": [
        "發表文章",
        "发布文章",
        "Publish"
      ],
      "result": "a[href*='pixnet.net/blog/post/']",
      "lands_on_post": true
    },
    "upstream_ref": "ondit-catalog:2026-09-28"
  },
  {
    "id": "post-smzdm",
    "name": "什么值得买",
    "methods": [
      "browser"
    ],
    "entry_url": "https://post.smzdm.com/tougao/",
    "dynamic_host": false,
    "hosts": [
      "post.smzdm.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input[name='title']",
            "textarea[name='title']",
            "input[placeholder*='title' i]",
            "textarea[placeholder*='title' i]",
            "input[placeholder*='标题']",
            "textarea[placeholder*='标题']",
            "input[placeholder*='標題']"
          ]
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea[name='body']",
            "textarea[name='content']",
            "[contenteditable='true'][role='textbox']",
            ".ProseMirror[contenteditable='true']",
            ".CodeMirror textarea",
            "textarea[placeholder*='content' i]",
            "textarea[placeholder*='正文']",
            "textarea[placeholder*='内容']"
          ],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in publishing account, Ondit fills the editor, uses the platform's visible publish controls, and verifies the resulting public URL. Login, CAPTCHA, moderation, payment and identity checks pause the task instead of being bypassed.",
        "发布账号已登录时，Ondit 会填写编辑器、操作平台可见的发布控件并验证公开链接。登录、验证码、内容审核、付款或实名验证会暂停任务，不会绕过。"
      ]
    },
    "unattended": {
      "editor_paths": [
        "^/tougao/"
      ],
      "account": "a[href*='/user/'],a[href*='/p/']",
      "submit": "button[type='submit'],button,[role='button']",
      "submit_text": [
        "发布",
        "提交审核"
      ],
      "confirm_submit": "[role='dialog'] button,.modal button,.drawer button",
      "confirm_submit_text": [
        "确认提交",
        "提交审核"
      ],
      "result": "a[href*='/p/']",
      "lands_on_post": true
    },
    "upstream_ref": "ondit-catalog:2026-09-28"
  },
  {
    "id": "qiita",
    "name": "Qiita",
    "methods": [
      "browser"
    ],
    "entry_url": "https://qiita.com/drafts/new",
    "dynamic_host": false,
    "hosts": [
      "qiita.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input[name='title']",
            "textarea[name='title']",
            "input[placeholder*='title' i]",
            "textarea[placeholder*='title' i]",
            "input[placeholder*='标题']",
            "textarea[placeholder*='标题']",
            "input[placeholder*='標題']"
          ]
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea[name='body']",
            "textarea[name='content']",
            "[contenteditable='true'][role='textbox']",
            ".ProseMirror[contenteditable='true']",
            ".CodeMirror textarea",
            "textarea[placeholder*='content' i]",
            "textarea[placeholder*='正文']",
            "textarea[placeholder*='内容']"
          ],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in publishing account, Ondit fills the editor, uses the platform's visible publish controls, and verifies the resulting public URL. Login, CAPTCHA, moderation, payment and identity checks pause the task instead of being bypassed.",
        "发布账号已登录时，Ondit 会填写编辑器、操作平台可见的发布控件并验证公开链接。登录、验证码、内容审核、付款或实名验证会暂停任务，不会绕过。"
      ]
    },
    "unattended": {
      "editor_paths": [
        "^/drafts/(?:new|[^/]+/edit)"
      ],
      "account": "a[href^='/'][data-testid*='profile'],a[href*='/settings/profile']",
      "submit": "button[type='submit'],button,[role='button']",
      "submit_text": [
        "公開する",
        "Publish"
      ],
      "confirm_submit": "[role='dialog'] button,.modal button,.drawer button",
      "confirm_submit_text": [
        "公開",
        "Publish"
      ],
      "result": "a[href*='/items/']",
      "lands_on_post": true
    },
    "upstream_ref": "ondit-catalog:2026-09-28"
  },
  {
    "id": "sspai",
    "name": "少数派",
    "methods": [
      "browser"
    ],
    "entry_url": "https://sspai.com/write",
    "dynamic_host": false,
    "hosts": [
      "sspai.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input[name='title']",
            "textarea[name='title']",
            "input[placeholder*='title' i]",
            "textarea[placeholder*='title' i]",
            "input[placeholder*='标题']",
            "textarea[placeholder*='标题']",
            "input[placeholder*='標題']"
          ]
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea[name='body']",
            "textarea[name='content']",
            "[contenteditable='true'][role='textbox']",
            ".ProseMirror[contenteditable='true']",
            ".CodeMirror textarea",
            "textarea[placeholder*='content' i]",
            "textarea[placeholder*='正文']",
            "textarea[placeholder*='内容']"
          ],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in publishing account, Ondit fills the editor, uses the platform's visible publish controls, and verifies the resulting public URL. Login, CAPTCHA, moderation, payment and identity checks pause the task instead of being bypassed.",
        "发布账号已登录时，Ondit 会填写编辑器、操作平台可见的发布控件并验证公开链接。登录、验证码、内容审核、付款或实名验证会暂停任务，不会绕过。"
      ]
    },
    "unattended": {
      "editor_paths": [
        "^/write(?:/|$)"
      ],
      "account": "a[href*='/u/'],a[href*='/user/']",
      "submit": "button[type='submit'],button,[role='button']",
      "submit_text": [
        "发布",
        "提交审核"
      ],
      "confirm_submit": "[role='dialog'] button,.modal button,.drawer button",
      "confirm_submit_text": [
        "确认提交",
        "提交审核"
      ],
      "result": "a[href*='/post/']",
      "lands_on_post": true
    },
    "upstream_ref": "ondit-catalog:2026-09-28"
  },
  {
    "id": "velog",
    "name": "Velog",
    "methods": [
      "browser"
    ],
    "entry_url": "https://velog.io/write",
    "dynamic_host": false,
    "hosts": [
      "velog.io"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input[name='title']",
            "textarea[name='title']",
            "input[placeholder*='title' i]",
            "textarea[placeholder*='title' i]",
            "input[placeholder*='标题']",
            "textarea[placeholder*='标题']",
            "input[placeholder*='標題']"
          ]
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea[name='body']",
            "textarea[name='content']",
            "[contenteditable='true'][role='textbox']",
            ".ProseMirror[contenteditable='true']",
            ".CodeMirror textarea",
            "textarea[placeholder*='content' i]",
            "textarea[placeholder*='正文']",
            "textarea[placeholder*='内容']"
          ],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in publishing account, Ondit fills the editor, uses the platform's visible publish controls, and verifies the resulting public URL. Login, CAPTCHA, moderation, payment and identity checks pause the task instead of being bypassed.",
        "发布账号已登录时，Ondit 会填写编辑器、操作平台可见的发布控件并验证公开链接。登录、验证码、内容审核、付款或实名验证会暂停任务，不会绕过。"
      ]
    },
    "unattended": {
      "editor_paths": [
        "^/write(?:/|$)"
      ],
      "account": "a[href^='/@']",
      "submit": "button[type='submit'],button,[role='button']",
      "submit_text": [
        "출간하기",
        "Publish"
      ],
      "confirm_submit": "[role='dialog'] button,.modal button,.drawer button",
      "confirm_submit_text": [
        "출간",
        "Publish"
      ],
      "result": "a[href^='/@'][href*='/']",
      "lands_on_post": true
    },
    "upstream_ref": "ondit-catalog:2026-09-28"
  },
  {
    "id": "woshipm",
    "name": "人人都是产品经理",
    "methods": [
      "browser"
    ],
    "entry_url": "https://www.woshipm.com/ucenter/write",
    "dynamic_host": false,
    "hosts": [
      "www.woshipm.com",
      "woshipm.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input[name='title']",
            "textarea[name='title']",
            "input[placeholder*='title' i]",
            "textarea[placeholder*='title' i]",
            "input[placeholder*='标题']",
            "textarea[placeholder*='标题']",
            "input[placeholder*='標題']"
          ]
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea[name='body']",
            "textarea[name='content']",
            "[contenteditable='true'][role='textbox']",
            ".ProseMirror[contenteditable='true']",
            ".CodeMirror textarea",
            "textarea[placeholder*='content' i]",
            "textarea[placeholder*='正文']",
            "textarea[placeholder*='内容']"
          ],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in publishing account, Ondit fills the editor, uses the platform's visible publish controls, and verifies the resulting public URL. Login, CAPTCHA, moderation, payment and identity checks pause the task instead of being bypassed.",
        "发布账号已登录时，Ondit 会填写编辑器、操作平台可见的发布控件并验证公开链接。登录、验证码、内容审核、付款或实名验证会暂停任务，不会绕过。"
      ]
    },
    "unattended": {
      "editor_paths": [
        "/ucenter/(?:write|edit)"
      ],
      "account": "a[href*='/ucenter'],a[href*='/user/']",
      "submit": "button[type='submit'],button,[role='button']",
      "submit_text": [
        "发布",
        "提交审核"
      ],
      "confirm_submit": "[role='dialog'] button,.modal button,.drawer button",
      "confirm_submit_text": [
        "确认提交",
        "提交审核"
      ],
      "result": "a[href*='woshipm.com/'][href*='.html']",
      "lands_on_post": true
    },
    "upstream_ref": "ondit-catalog:2026-09-28"
  },
  {
    "id": "wip",
    "name": "WIP",
    "methods": [
      "browser"
    ],
    "entry_url": "https://wip.co/",
    "dynamic_host": false,
    "hosts": [
      "wip.co"
    ],
    "preview": {
      "layout": "social",
      "fields": [
        {
          "key": "body",
          "label": [
            "Post",
            "内容"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea[placeholder*='Ship something' i]",
            "input[placeholder*='Ship something' i]",
            "[contenteditable='true'][aria-label*='Ship something' i]"
          ],
          "format": "plain"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "unattended",
      "final_action": "automated",
      "instructions": [
        "With a signed-in publishing account, Ondit fills the editor, uses the platform's visible publish controls, and verifies the resulting public URL. Login, CAPTCHA, moderation, payment and identity checks pause the task instead of being bypassed.",
        "发布账号已登录时，Ondit 会填写编辑器、操作平台可见的发布控件并验证公开链接。登录、验证码、内容审核、付款或实名验证会暂停任务，不会绕过。"
      ]
    },
    "unattended": {
      "editor_paths": [
        "^/$"
      ],
      "account": "a[href^='/@']",
      "submit": "textarea[placeholder*='Ship something' i],input[placeholder*='Ship something' i],[contenteditable='true'][aria-label*='Ship something' i]",
      "submit_key": "Enter",
      "result": "a[href*='/todos/'],a[href*='/posts/']",
      "lands_on_post": true
    },
    "upstream_ref": "ondit-catalog:2026-09-28"
  },
  {
    "id": "jiemian",
    "name": "界面新闻",
    "methods": [
      "manual"
    ],
    "entry_url": "https://www.jiemian.com/",
    "dynamic_host": false,
    "hosts": [
      "jiemian.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "editorial_review",
      "fill": "assisted",
      "final_action": "user_or_platform",
      "instructions": [
        "This publisher accepts pitches or editorial submissions rather than self-serve posts. Ondit prepares the article and opens the publisher, but an editor decides whether and where it is published; no browser can truthfully return a public URL at the scheduled time.",
        "该平台接收选题或编辑投稿，不提供自助发帖。Ondit 会准备内容并打开投稿入口，但是否及何时刊发由编辑决定，浏览器无法在预约时间可靠回填公开链接。"
      ]
    },
    "upstream_ref": "ondit-catalog:2026-09-30"
  },
  {
    "id": "huxiu",
    "name": "虎嗅",
    "methods": [
      "manual"
    ],
    "entry_url": "https://www.huxiu.com/",
    "dynamic_host": false,
    "hosts": [
      "huxiu.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "editorial_review",
      "fill": "assisted",
      "final_action": "user_or_platform",
      "instructions": [
        "This publisher accepts pitches or editorial submissions rather than self-serve posts. Ondit prepares the article and opens the publisher, but an editor decides whether and where it is published; no browser can truthfully return a public URL at the scheduled time.",
        "该平台接收选题或编辑投稿，不提供自助发帖。Ondit 会准备内容并打开投稿入口，但是否及何时刊发由编辑决定，浏览器无法在预约时间可靠回填公开链接。"
      ]
    },
    "upstream_ref": "ondit-catalog:2026-09-30"
  },
  {
    "id": "tmtpost",
    "name": "钛媒体",
    "methods": [
      "manual"
    ],
    "entry_url": "https://www.tmtpost.com/",
    "dynamic_host": false,
    "hosts": [
      "tmtpost.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "editorial_review",
      "fill": "assisted",
      "final_action": "user_or_platform",
      "instructions": [
        "This publisher accepts pitches or editorial submissions rather than self-serve posts. Ondit prepares the article and opens the publisher, but an editor decides whether and where it is published; no browser can truthfully return a public URL at the scheduled time.",
        "该平台接收选题或编辑投稿，不提供自助发帖。Ondit 会准备内容并打开投稿入口，但是否及何时刊发由编辑决定，浏览器无法在预约时间可靠回填公开链接。"
      ]
    },
    "upstream_ref": "ondit-catalog:2026-09-30"
  },
  {
    "id": "leiphone",
    "name": "雷峰网",
    "methods": [
      "manual"
    ],
    "entry_url": "https://www.leiphone.com/",
    "dynamic_host": false,
    "hosts": [
      "leiphone.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "editorial_review",
      "fill": "assisted",
      "final_action": "user_or_platform",
      "instructions": [
        "This publisher accepts pitches or editorial submissions rather than self-serve posts. Ondit prepares the article and opens the publisher, but an editor decides whether and where it is published; no browser can truthfully return a public URL at the scheduled time.",
        "该平台接收选题或编辑投稿，不提供自助发帖。Ondit 会准备内容并打开投稿入口，但是否及何时刊发由编辑决定，浏览器无法在预约时间可靠回填公开链接。"
      ]
    },
    "upstream_ref": "ondit-catalog:2026-09-30"
  },
  {
    "id": "ebrun",
    "name": "亿邦动力",
    "methods": [
      "manual"
    ],
    "entry_url": "https://www.ebrun.com/",
    "dynamic_host": false,
    "hosts": [
      "ebrun.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "editorial_review",
      "fill": "assisted",
      "final_action": "user_or_platform",
      "instructions": [
        "This publisher accepts pitches or editorial submissions rather than self-serve posts. Ondit prepares the article and opens the publisher, but an editor decides whether and where it is published; no browser can truthfully return a public URL at the scheduled time.",
        "该平台接收选题或编辑投稿，不提供自助发帖。Ondit 会准备内容并打开投稿入口，但是否及何时刊发由编辑决定，浏览器无法在预约时间可靠回填公开链接。"
      ]
    },
    "upstream_ref": "ondit-catalog:2026-09-30"
  },
  {
    "id": "iyiou",
    "name": "亿欧",
    "methods": [
      "manual"
    ],
    "entry_url": "https://www.iyiou.com/",
    "dynamic_host": false,
    "hosts": [
      "iyiou.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "editorial_review",
      "fill": "assisted",
      "final_action": "user_or_platform",
      "instructions": [
        "This publisher accepts pitches or editorial submissions rather than self-serve posts. Ondit prepares the article and opens the publisher, but an editor decides whether and where it is published; no browser can truthfully return a public URL at the scheduled time.",
        "该平台接收选题或编辑投稿，不提供自助发帖。Ondit 会准备内容并打开投稿入口，但是否及何时刊发由编辑决定，浏览器无法在预约时间可靠回填公开链接。"
      ]
    },
    "upstream_ref": "ondit-catalog:2026-09-30"
  },
  {
    "id": "cyzone",
    "name": "创业邦",
    "methods": [
      "manual"
    ],
    "entry_url": "https://www.cyzone.cn/",
    "dynamic_host": false,
    "hosts": [
      "cyzone.cn"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "editorial_review",
      "fill": "assisted",
      "final_action": "user_or_platform",
      "instructions": [
        "This publisher accepts pitches or editorial submissions rather than self-serve posts. Ondit prepares the article and opens the publisher, but an editor decides whether and where it is published; no browser can truthfully return a public URL at the scheduled time.",
        "该平台接收选题或编辑投稿，不提供自助发帖。Ondit 会准备内容并打开投稿入口，但是否及何时刊发由编辑决定，浏览器无法在预约时间可靠回填公开链接。"
      ]
    },
    "upstream_ref": "ondit-catalog:2026-09-30"
  },
  {
    "id": "pingwest",
    "name": "品玩 PingWest",
    "methods": [
      "manual"
    ],
    "entry_url": "https://www.pingwest.com/",
    "dynamic_host": false,
    "hosts": [
      "pingwest.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "editorial_review",
      "fill": "assisted",
      "final_action": "user_or_platform",
      "instructions": [
        "This publisher accepts pitches or editorial submissions rather than self-serve posts. Ondit prepares the article and opens the publisher, but an editor decides whether and where it is published; no browser can truthfully return a public URL at the scheduled time.",
        "该平台接收选题或编辑投稿，不提供自助发帖。Ondit 会准备内容并打开投稿入口，但是否及何时刊发由编辑决定，浏览器无法在预约时间可靠回填公开链接。"
      ]
    },
    "upstream_ref": "ondit-catalog:2026-09-30"
  },
  {
    "id": "hao-logosc",
    "name": "神器集",
    "methods": [
      "manual"
    ],
    "entry_url": "https://hao.logosc.cn/",
    "dynamic_host": false,
    "hosts": [
      "hao.logosc.cn"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "editorial_review",
      "fill": "assisted",
      "final_action": "user_or_platform",
      "instructions": [
        "This publisher accepts pitches or editorial submissions rather than self-serve posts. Ondit prepares the article and opens the publisher, but an editor decides whether and where it is published; no browser can truthfully return a public URL at the scheduled time.",
        "该平台接收选题或编辑投稿，不提供自助发帖。Ondit 会准备内容并打开投稿入口，但是否及何时刊发由编辑决定，浏览器无法在预约时间可靠回填公开链接。"
      ]
    },
    "upstream_ref": "ondit-catalog:2026-09-30"
  },
  {
    "id": "iplaysoft",
    "name": "异次元软件世界",
    "methods": [
      "manual"
    ],
    "entry_url": "https://www.iplaysoft.com/",
    "dynamic_host": false,
    "hosts": [
      "iplaysoft.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "editorial_review",
      "fill": "assisted",
      "final_action": "user_or_platform",
      "instructions": [
        "This publisher accepts pitches or editorial submissions rather than self-serve posts. Ondit prepares the article and opens the publisher, but an editor decides whether and where it is published; no browser can truthfully return a public URL at the scheduled time.",
        "该平台接收选题或编辑投稿，不提供自助发帖。Ondit 会准备内容并打开投稿入口，但是否及何时刊发由编辑决定，浏览器无法在预约时间可靠回填公开链接。"
      ]
    },
    "upstream_ref": "ondit-catalog:2026-09-30"
  },
  {
    "id": "ghxi",
    "name": "果核剥壳",
    "methods": [
      "manual"
    ],
    "entry_url": "https://www.ghxi.com/",
    "dynamic_host": false,
    "hosts": [
      "ghxi.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "editorial_review",
      "fill": "assisted",
      "final_action": "user_or_platform",
      "instructions": [
        "This publisher accepts pitches or editorial submissions rather than self-serve posts. Ondit prepares the article and opens the publisher, but an editor decides whether and where it is published; no browser can truthfully return a public URL at the scheduled time.",
        "该平台接收选题或编辑投稿，不提供自助发帖。Ondit 会准备内容并打开投稿入口，但是否及何时刊发由编辑决定，浏览器无法在预约时间可靠回填公开链接。"
      ]
    },
    "upstream_ref": "ondit-catalog:2026-09-30"
  },
  {
    "id": "ahhhhfs",
    "name": "ahhhhfs",
    "methods": [
      "manual"
    ],
    "entry_url": "https://www.ahhhhfs.com",
    "dynamic_host": false,
    "hosts": [
      "ahhhhfs.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "editorial_review",
      "fill": "assisted",
      "final_action": "user_or_platform",
      "instructions": [
        "This publisher accepts pitches or editorial submissions rather than self-serve posts. Ondit prepares the article and opens the publisher, but an editor decides whether and where it is published; no browser can truthfully return a public URL at the scheduled time.",
        "该平台接收选题或编辑投稿，不提供自助发帖。Ondit 会准备内容并打开投稿入口，但是否及何时刊发由编辑决定，浏览器无法在预约时间可靠回填公开链接。"
      ]
    },
    "upstream_ref": "ondit-catalog:2026-09-30"
  },
  {
    "id": "lieyunpro",
    "name": "猎云网",
    "methods": [
      "manual"
    ],
    "entry_url": "https://www.lieyunpro.com/",
    "dynamic_host": false,
    "hosts": [
      "lieyunpro.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "editorial_review",
      "fill": "assisted",
      "final_action": "user_or_platform",
      "instructions": [
        "This publisher accepts pitches or editorial submissions rather than self-serve posts. Ondit prepares the article and opens the publisher, but an editor decides whether and where it is published; no browser can truthfully return a public URL at the scheduled time.",
        "该平台接收选题或编辑投稿，不提供自助发帖。Ondit 会准备内容并打开投稿入口，但是否及何时刊发由编辑决定，浏览器无法在预约时间可靠回填公开链接。"
      ]
    },
    "upstream_ref": "ondit-catalog:2026-09-30"
  },
  {
    "id": "starter-story",
    "name": "Starter Story",
    "methods": [
      "manual"
    ],
    "entry_url": "https://starterstory.com",
    "dynamic_host": false,
    "hosts": [
      "starterstory.com"
    ],
    "preview": {
      "layout": "social",
      "fields": [
        {
          "key": "body",
          "label": [
            "Post",
            "内容"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "plain"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "editorial_review",
      "fill": "assisted",
      "final_action": "user_or_platform",
      "instructions": [
        "This publisher accepts pitches or editorial submissions rather than self-serve posts. Ondit prepares the article and opens the publisher, but an editor decides whether and where it is published; no browser can truthfully return a public URL at the scheduled time.",
        "该平台接收选题或编辑投稿，不提供自助发帖。Ondit 会准备内容并打开投稿入口，但是否及何时刊发由编辑决定，浏览器无法在预约时间可靠回填公开链接。"
      ]
    },
    "upstream_ref": "ondit-catalog:2026-09-30"
  },
  {
    "id": "pr-newswire",
    "name": "PR Newswire",
    "methods": [
      "manual"
    ],
    "entry_url": "https://www.prnewswire.com",
    "dynamic_host": false,
    "hosts": [
      "prnewswire.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "paid_order",
      "fill": "assisted",
      "final_action": "user_or_platform",
      "instructions": [
        "This is a paid press-release order. Ondit prepares the release, but choosing distribution, accepting the price and placing the order are financial actions that cannot be performed as an unattended browser post.",
        "这是付费新闻稿订单。Ondit 会准备新闻稿，但选择分发范围、接受价格并下单属于付款操作，不能伪装成无人值守的普通发帖。"
      ]
    },
    "upstream_ref": "ondit-catalog:2026-09-30"
  },
  {
    "id": "business-wire",
    "name": "Business Wire",
    "methods": [
      "manual"
    ],
    "entry_url": "https://www.businesswire.com",
    "dynamic_host": false,
    "hosts": [
      "businesswire.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "paid_order",
      "fill": "assisted",
      "final_action": "user_or_platform",
      "instructions": [
        "This is a paid press-release order. Ondit prepares the release, but choosing distribution, accepting the price and placing the order are financial actions that cannot be performed as an unattended browser post.",
        "这是付费新闻稿订单。Ondit 会准备新闻稿，但选择分发范围、接受价格并下单属于付款操作，不能伪装成无人值守的普通发帖。"
      ]
    },
    "upstream_ref": "ondit-catalog:2026-09-30"
  },
  {
    "id": "ein-presswire",
    "name": "EIN Presswire",
    "methods": [
      "manual"
    ],
    "entry_url": "https://www.einpresswire.com",
    "dynamic_host": false,
    "hosts": [
      "einpresswire.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "paid_order",
      "fill": "assisted",
      "final_action": "user_or_platform",
      "instructions": [
        "This is a paid press-release order. Ondit prepares the release, but choosing distribution, accepting the price and placing the order are financial actions that cannot be performed as an unattended browser post.",
        "这是付费新闻稿订单。Ondit 会准备新闻稿，但选择分发范围、接受价格并下单属于付款操作，不能伪装成无人值守的普通发帖。"
      ]
    },
    "upstream_ref": "ondit-catalog:2026-09-30"
  },
  {
    "id": "prnasia",
    "name": "美通社 PR Newswire",
    "methods": [
      "manual"
    ],
    "entry_url": "https://www.prnasia.com/",
    "dynamic_host": false,
    "hosts": [
      "prnasia.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "paid_order",
      "fill": "assisted",
      "final_action": "user_or_platform",
      "instructions": [
        "This is a paid press-release order. Ondit prepares the release, but choosing distribution, accepting the price and placing the order are financial actions that cannot be performed as an unattended browser post.",
        "这是付费新闻稿订单。Ondit 会准备新闻稿，但选择分发范围、接受价格并下单属于付款操作，不能伪装成无人值守的普通发帖。"
      ]
    },
    "upstream_ref": "ondit-catalog:2026-09-30"
  },
  {
    "id": "zhidao-baidu",
    "name": "百度知道",
    "methods": [
      "manual"
    ],
    "entry_url": "https://zhidao.baidu.com/",
    "dynamic_host": false,
    "hosts": [
      "zhidao.baidu.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "request_specific",
      "fill": "assisted",
      "final_action": "user_or_platform",
      "instructions": [
        "A real question, journalist request or issue must be selected before writing. Ondit prepares a response after that destination is chosen; it does not broadcast an unrelated article into an arbitrary request.",
        "必须先选择真实问题、记者需求或指定议题，Ondit 才能据此准备回复；不会把普通文章自动投到任意问题中。"
      ]
    },
    "upstream_ref": "ondit-catalog:2026-09-30"
  },
  {
    "id": "stackoverflow",
    "name": "StackOverflow",
    "methods": [
      "manual"
    ],
    "entry_url": "https://stackoverflow.com/",
    "dynamic_host": false,
    "hosts": [
      "stackoverflow.com"
    ],
    "preview": {
      "layout": "social",
      "fields": [
        {
          "key": "body",
          "label": [
            "Post",
            "内容"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "plain"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "request_specific",
      "fill": "assisted",
      "final_action": "user_or_platform",
      "instructions": [
        "A real question, journalist request or issue must be selected before writing. Ondit prepares a response after that destination is chosen; it does not broadcast an unrelated article into an arbitrary request.",
        "必须先选择真实问题、记者需求或指定议题，Ondit 才能据此准备回复；不会把普通文章自动投到任意问题中。"
      ]
    },
    "upstream_ref": "ondit-catalog:2026-09-30"
  },
  {
    "id": "ruanyifeng",
    "name": "科技爱好者周刊",
    "methods": [
      "manual"
    ],
    "entry_url": "https://www.ruanyifeng.com/blog/weekly/",
    "dynamic_host": false,
    "hosts": [
      "ruanyifeng.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "request_specific",
      "fill": "assisted",
      "final_action": "user_or_platform",
      "instructions": [
        "A real question, journalist request or issue must be selected before writing. Ondit prepares a response after that destination is chosen; it does not broadcast an unrelated article into an arbitrary request.",
        "必须先选择真实问题、记者需求或指定议题，Ondit 才能据此准备回复；不会把普通文章自动投到任意问题中。"
      ]
    },
    "upstream_ref": "ondit-catalog:2026-09-30"
  },
  {
    "id": "haro",
    "name": "HARO (Help A Reporter Out)",
    "methods": [
      "manual"
    ],
    "entry_url": "https://www.helpareporter.com",
    "dynamic_host": false,
    "hosts": [
      "helpareporter.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "request_specific",
      "fill": "assisted",
      "final_action": "user_or_platform",
      "instructions": [
        "A real question, journalist request or issue must be selected before writing. Ondit prepares a response after that destination is chosen; it does not broadcast an unrelated article into an arbitrary request.",
        "必须先选择真实问题、记者需求或指定议题，Ondit 才能据此准备回复；不会把普通文章自动投到任意问题中。"
      ]
    },
    "upstream_ref": "ondit-catalog:2026-09-30"
  },
  {
    "id": "qwoted",
    "name": "Qwoted",
    "methods": [
      "manual"
    ],
    "entry_url": "https://www.qwoted.com",
    "dynamic_host": false,
    "hosts": [
      "qwoted.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "request_specific",
      "fill": "assisted",
      "final_action": "user_or_platform",
      "instructions": [
        "A real question, journalist request or issue must be selected before writing. Ondit prepares a response after that destination is chosen; it does not broadcast an unrelated article into an arbitrary request.",
        "必须先选择真实问题、记者需求或指定议题，Ondit 才能据此准备回复；不会把普通文章自动投到任意问题中。"
      ]
    },
    "upstream_ref": "ondit-catalog:2026-09-30"
  },
  {
    "id": "featured-com",
    "name": "Featured.com",
    "methods": [
      "manual"
    ],
    "entry_url": "https://featured.com",
    "dynamic_host": false,
    "hosts": [
      "featured.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "request_specific",
      "fill": "assisted",
      "final_action": "user_or_platform",
      "instructions": [
        "A real question, journalist request or issue must be selected before writing. Ondit prepares a response after that destination is chosen; it does not broadcast an unrelated article into an arbitrary request.",
        "必须先选择真实问题、记者需求或指定议题，Ondit 才能据此准备回复；不会把普通文章自动投到任意问题中。"
      ]
    },
    "upstream_ref": "ondit-catalog:2026-09-30"
  },
  {
    "id": "mentionmatch",
    "name": "MentionMatch (原Help a B2B Writer)",
    "methods": [
      "manual"
    ],
    "entry_url": "https://mentionmatch.com",
    "dynamic_host": false,
    "hosts": [
      "mentionmatch.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "request_specific",
      "fill": "assisted",
      "final_action": "user_or_platform",
      "instructions": [
        "A real question, journalist request or issue must be selected before writing. Ondit prepares a response after that destination is chosen; it does not broadcast an unrelated article into an arbitrary request.",
        "必须先选择真实问题、记者需求或指定议题，Ondit 才能据此准备回复；不会把普通文章自动投到任意问题中。"
      ]
    },
    "upstream_ref": "ondit-catalog:2026-09-30"
  },
  {
    "id": "sourcebottle",
    "name": "SourceBottle",
    "methods": [
      "manual"
    ],
    "entry_url": "https://www.sourcebottle.com",
    "dynamic_host": false,
    "hosts": [
      "sourcebottle.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "request_specific",
      "fill": "assisted",
      "final_action": "user_or_platform",
      "instructions": [
        "A real question, journalist request or issue must be selected before writing. Ondit prepares a response after that destination is chosen; it does not broadcast an unrelated article into an arbitrary request.",
        "必须先选择真实问题、记者需求或指定议题，Ondit 才能据此准备回复；不会把普通文章自动投到任意问题中。"
      ]
    },
    "upstream_ref": "ondit-catalog:2026-09-30"
  },
  {
    "id": "jingyan-baidu",
    "name": "百度经验",
    "methods": [
      "manual"
    ],
    "entry_url": "https://jingyan.baidu.com/",
    "dynamic_host": false,
    "hosts": [
      "jingyan.baidu.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "structured_submission",
      "fill": "assisted",
      "final_action": "user_or_platform",
      "instructions": [
        "The destination uses a multi-part submission rather than a reusable article editor. Ondit transfers the approved text and opens the form; required business, contact, category or step data must be completed for this submission.",
        "该渠道使用多段式提交表单，而不是可复用文章编辑器。Ondit 会转移已确认内容并打开表单；本次投稿所需的企业、联系、分类或步骤资料仍需补齐。"
      ]
    },
    "upstream_ref": "ondit-catalog:2026-09-30"
  },
  {
    "id": "pitchhub-36kr",
    "name": "36氪 创投平台",
    "methods": [
      "manual"
    ],
    "entry_url": "https://pitchhub.36kr.com/",
    "dynamic_host": false,
    "hosts": [
      "pitchhub.36kr.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "structured_submission",
      "fill": "assisted",
      "final_action": "user_or_platform",
      "instructions": [
        "The destination uses a multi-part submission rather than a reusable article editor. Ondit transfers the approved text and opens the form; required business, contact, category or step data must be completed for this submission.",
        "该渠道使用多段式提交表单，而不是可复用文章编辑器。Ondit 会转移已确认内容并打开表单；本次投稿所需的企业、联系、分类或步骤资料仍需补齐。"
      ]
    },
    "upstream_ref": "ondit-catalog:2026-09-30"
  },
  {
    "id": "openpr",
    "name": "openPR",
    "methods": [
      "manual"
    ],
    "entry_url": "https://www.openpr.com",
    "dynamic_host": false,
    "hosts": [
      "openpr.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "structured_submission",
      "fill": "assisted",
      "final_action": "user_or_platform",
      "instructions": [
        "The destination uses a multi-part submission rather than a reusable article editor. Ondit transfers the approved text and opens the form; required business, contact, category or step data must be completed for this submission.",
        "该渠道使用多段式提交表单，而不是可复用文章编辑器。Ondit 会转移已确认内容并打开表单；本次投稿所需的企业、联系、分类或步骤资料仍需补齐。"
      ]
    },
    "upstream_ref": "ondit-catalog:2026-09-30"
  },
  {
    "id": "36dianping",
    "name": "36氪企服点评",
    "methods": [
      "manual"
    ],
    "entry_url": "https://www.36dianping.com/company-enter.html",
    "dynamic_host": false,
    "hosts": [
      "36dianping.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "structured_submission",
      "fill": "assisted",
      "final_action": "user_or_platform",
      "instructions": [
        "The destination uses a multi-part submission rather than a reusable article editor. Ondit transfers the approved text and opens the form; required business, contact, category or step data must be completed for this submission.",
        "该渠道使用多段式提交表单，而不是可复用文章编辑器。Ondit 会转移已确认内容并打开表单；本次投稿所需的企业、联系、分类或步骤资料仍需补齐。"
      ]
    },
    "upstream_ref": "ondit-catalog:2026-09-30"
  },
  {
    "id": "mergeek",
    "name": "Mergeek",
    "methods": [
      "manual"
    ],
    "entry_url": "https://mergeek.com/publish_project",
    "dynamic_host": false,
    "hosts": [
      "mergeek.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "structured_submission",
      "fill": "assisted",
      "final_action": "user_or_platform",
      "instructions": [
        "The destination uses a multi-part submission rather than a reusable article editor. Ondit transfers the approved text and opens the form; required business, contact, category or step data must be completed for this submission.",
        "该渠道使用多段式提交表单，而不是可复用文章编辑器。Ondit 会转移已确认内容并打开表单；本次投稿所需的企业、联系、分类或步骤资料仍需补齐。"
      ]
    },
    "upstream_ref": "ondit-catalog:2026-09-30"
  },
  {
    "id": "ximalaya",
    "name": "喜马拉雅",
    "methods": [
      "manual"
    ],
    "entry_url": "https://www.ximalaya.com/",
    "dynamic_host": false,
    "hosts": [
      "ximalaya.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "rich_text"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "media_required",
      "fill": "assisted",
      "final_action": "user_or_platform",
      "instructions": [
        "This channel publishes an audio episode. A text article is prepared as the description, but an approved audio file and its episode settings are required before it can be scheduled.",
        "该渠道发布音频节目。文章可作为简介，但排期前必须提供已确认的音频文件和节目设置。"
      ]
    },
    "upstream_ref": "ondit-catalog:2026-09-30"
  },
  {
    "id": "bbs-hupu",
    "name": "虎扑社区",
    "methods": [
      "manual"
    ],
    "entry_url": "https://bbs.hupu.com/all-digital",
    "dynamic_host": false,
    "hosts": [
      "bbs.hupu.com"
    ],
    "preview": {
      "layout": "social",
      "fields": [
        {
          "key": "body",
          "label": [
            "Post",
            "内容"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "plain"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "destination_required",
      "fill": "assisted",
      "final_action": "user_or_platform",
      "instructions": [
        "A forum section must be chosen first because each section has different posting rules. Ondit prepares and transfers the post after a destination is selected.",
        "必须先选择论坛版块，因为各版块发帖规则不同；选择目标版块后，Ondit 才会准备并转移帖子。"
      ]
    },
    "upstream_ref": "ondit-catalog:2026-09-30"
  },
  {
    "id": "bbs-pcbeta",
    "name": "远景论坛",
    "methods": [
      "manual"
    ],
    "entry_url": "https://bbs.pcbeta.com/",
    "dynamic_host": false,
    "hosts": [
      "bbs.pcbeta.com"
    ],
    "preview": {
      "layout": "social",
      "fields": [
        {
          "key": "body",
          "label": [
            "Post",
            "内容"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "plain"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "destination_required",
      "fill": "assisted",
      "final_action": "user_or_platform",
      "instructions": [
        "A forum section must be chosen first because each section has different posting rules. Ondit prepares and transfers the post after a destination is selected.",
        "必须先选择论坛版块，因为各版块发帖规则不同；选择目标版块后，Ondit 才会准备并转移帖子。"
      ]
    },
    "upstream_ref": "ondit-catalog:2026-09-30"
  },
  {
    "id": "nextdoor-business-page",
    "name": "Nextdoor Business Page",
    "methods": [
      "manual"
    ],
    "entry_url": "https://business.nextdoor.com/",
    "dynamic_host": false,
    "hosts": [
      "business.nextdoor.com"
    ],
    "preview": {
      "layout": "social",
      "fields": [
        {
          "key": "body",
          "label": [
            "Post",
            "内容"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "plain"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "account_verification",
      "fill": "assisted",
      "final_action": "user_or_platform",
      "instructions": [
        "Posting is available only from a claimed and verified local business page. Ondit opens the business workflow and prepares the post; the account must first expose a verified page and its local audience.",
        "只有已认领并验证的本地商家主页才能发布。Ondit 会打开商家流程并准备内容；账号必须先具备已验证主页及其本地受众。"
      ]
    },
    "upstream_ref": "ondit-catalog:2026-09-30"
  },
  {
    "id": "neighbourly",
    "name": "Neighbourly",
    "methods": [
      "manual"
    ],
    "entry_url": "https://www.neighbourly.co.nz/",
    "dynamic_host": false,
    "hosts": [
      "neighbourly.co.nz"
    ],
    "preview": {
      "layout": "social",
      "fields": [
        {
          "key": "body",
          "label": [
            "Post",
            "内容"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "plain"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "no_current_editor",
      "fill": "assisted",
      "final_action": "user_or_platform",
      "instructions": [
        "The platform currently exposes no working desktop publishing editor. Ondit retains the prepared content and can resume when the platform restores a web editor.",
        "该平台当前没有可用的桌面网页发布编辑器。Ondit 会保留已准备内容，平台恢复网页编辑器后可继续。"
      ]
    },
    "upstream_ref": "ondit-catalog:2026-09-30"
  },
  {
    "id": "coolapk",
    "name": "酷安网",
    "methods": [
      "manual"
    ],
    "entry_url": "https://www.coolapk.com/",
    "dynamic_host": false,
    "hosts": [
      "coolapk.com"
    ],
    "preview": {
      "layout": "social",
      "fields": [
        {
          "key": "body",
          "label": [
            "Post",
            "内容"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "plain"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "no_current_editor",
      "fill": "assisted",
      "final_action": "user_or_platform",
      "instructions": [
        "The platform currently exposes no working desktop publishing editor. Ondit retains the prepared content and can resume when the platform restores a web editor.",
        "该平台当前没有可用的桌面网页发布编辑器。Ondit 会保留已准备内容，平台恢复网页编辑器后可继续。"
      ]
    },
    "upstream_ref": "ondit-catalog:2026-09-30"
  },
  {
    "id": "jike",
    "name": "即刻",
    "methods": [
      "manual"
    ],
    "entry_url": "https://web.okjike.com",
    "dynamic_host": false,
    "hosts": [
      "web.okjike.com"
    ],
    "preview": {
      "layout": "social",
      "fields": [
        {
          "key": "body",
          "label": [
            "Post",
            "内容"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "plain"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_editor",
      "fill": "assisted",
      "final_action": "user_or_platform",
      "instructions": [
        "The public site does not expose a stable publishing editor that can be validated without the account's live page. Ondit prepares the content and opens the platform, but unattended sending remains disabled until that editor is observed.",
        "公开页面没有可在账号外验证的稳定发布编辑器。Ondit 会准备内容并打开平台；在真实账号编辑器完成观察前不会启用无人值守发送。"
      ]
    },
    "upstream_ref": "ondit-catalog:2026-09-30"
  },
  {
    "id": "maimai",
    "name": "脉脉",
    "methods": [
      "manual"
    ],
    "entry_url": "https://maimai.cn/",
    "dynamic_host": false,
    "hosts": [
      "maimai.cn"
    ],
    "preview": {
      "layout": "social",
      "fields": [
        {
          "key": "body",
          "label": [
            "Post",
            "内容"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "plain"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_editor",
      "fill": "assisted",
      "final_action": "user_or_platform",
      "instructions": [
        "The public site does not expose a stable publishing editor that can be validated without the account's live page. Ondit prepares the content and opens the platform, but unattended sending remains disabled until that editor is observed.",
        "公开页面没有可在账号外验证的稳定发布编辑器。Ondit 会准备内容并打开平台；在真实账号编辑器完成观察前不会启用无人值守发送。"
      ]
    },
    "upstream_ref": "ondit-catalog:2026-09-30"
  }
]
